import "react-big-calendar/lib/css/react-big-calendar.css";

import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
// import { DatePicker, DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import { IconButton, TextField, Tooltip } from "@mui/material";
import React, { useState, useMemo } from "react";
import {
  useFetchProviderZipCodesMutation,
  useGetProviderAvailabilityMutation,
  useUpsertProviderAvailabilityMutation,
  useValidateDeletedDatesMutation,
} from "../../../../../features/provider/providerApiSlice";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloseIcon from "@mui/icons-material/Close";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MultiSectionDigitalClock } from "@mui/x-date-pickers/MultiSectionDigitalClock";
import dayjs from "dayjs";
import "moment-timezone";
import moment from "moment";
import { CoPresentOutlined } from "@mui/icons-material";
import {
  capitalizeFirstWords,
  groupAppointmentsByDate,
  groupMultiDayAppointmentsByDate,
  splitAllConsecutiveDateGroups,
  splitConsecutiveDates,
} from "../../../../../utilities/resuseFunctions";
import Select from "react-select";
import { useFetchAppointmentTypesMutation } from "../../../../../features/appointment/appointmentApiSlice";
import { useFetchZonesMutation } from "../../../../../features/zones/zonesApiSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../../features/auth/authSlice";
import { GeographicCoverageSection, LEAVE_TYPE } from "./ProviderSettingsModal";
import ReusableModal from "../../../../../components/Modals/ReusableModal";

const localizer = momentLocalizer(moment);

const days = [
  { id: 0, name: "Sun" },
  { id: 1, name: "Mon" },
  { id: 2, name: "Tue" },
  { id: 3, name: "Wed" },
  { id: 4, name: "Thu" },
  { id: 5, name: "Fri" },
  { id: 6, name: "Sat" },
];

const applyToDays = [
  { id: 0, name: "SUNDAY" },
  { id: 1, name: "MONDAY" },
  { id: 2, name: "TUESDAY" },
  { id: 3, name: "WEDNESDAY" },
  { id: 4, name: "THURSDAY" },
  { id: 5, name: "FRIDAY" },
  { id: 6, name: "SATURDAY" },
];

const US_TIMEZONE_MAP = {
  // Eastern Time
  EST: "America/New_York",
  EDT: "America/New_York",

  // Central Time
  CST: "America/Chicago",
  CDT: "America/Chicago",

  // Mountain Time
  MST: "America/Denver",
  MDT: "America/Denver",

  // Arizona (no DST)
  AZST: "America/Phoenix",
  AZ: "America/Phoenix",

  // Pacific Time
  PST: "America/Los_Angeles",
  PDT: "America/Los_Angeles",

  // Alaska
  AKST: "America/Anchorage",
  AKDT: "America/Anchorage",

  // Hawaii
  HST: "Pacific/Honolulu",

  // Puerto Rico & U.S. Virgin Islands
  AST: "America/Puerto_Rico",

  // Guam & Northern Mariana Islands
  CHST: "Pacific/Guam",

  // American Samoa
  SST: "Pacific/Pago_Pago",
};

const US_TIMEZONE_LABELS = {
  EST: "Eastern Standard Time",
  EDT: "Eastern Daylight Time",
  CST: "Central Standard Time",
  CDT: "Central Daylight Time",
  MST: "Mountain Standard Time",
  MDT: "Mountain Daylight Time",
  AZST: "Arizona Standard Time",
  AZ: "Arizona Standard Time",
  PST: "Pacific Standard Time",
  PDT: "Pacific Daylight Time",
  AKST: "Alaska Standard Time",
  AKDT: "Alaska Daylight Time",
  HST: "Hawaii Standard Time",
  AST: "Atlantic Standard Time",
  CHST: "Chamorro Standard Time",
  SST: "Samoa Standard Time",
  "AMERICA/NEW_YORK": "Eastern Standard Time",
  "AMERICA/CHICAGO": "Central Standard Time",
  "AMERICA/DENVER": "Mountain Standard Time",
  "AMERICA/PHOENIX": "Arizona Standard Time",
  "US/ARIZONA": "Arizona Standard Time",
  "AMERICA/LOS_ANGELES": "Pacific Standard Time",
  "AMERICA/ANCHORAGE": "Alaska Standard Time",
  "PACIFIC/HONOLULU": "Hawaii Standard Time",
  "AMERICA/PUERTO_RICO": "Atlantic Standard Time",
  "PACIFIC/GUAM": "Chamorro Standard Time",
  "PACIFIC/PAGO_PAGO": "Samoa Standard Time",
};

const IANA_TO_ABBREVIATION = {
  "AMERICA/NEW_YORK": "EST",
  "AMERICA/CHICAGO": "CST",
  "AMERICA/DENVER": "MST",
  "AMERICA/PHOENIX": "AZST",
  "US/ARIZONA": "AZST",
  "AMERICA/LOS_ANGELES": "PST",
  "AMERICA/ANCHORAGE": "AKST",
  "PACIFIC/HONOLULU": "HST",
  "AMERICA/PUERTO_RICO": "AST",
  "PACIFIC/GUAM": "CHST",
  "PACIFIC/PAGO_PAGO": "SST",
};

function CalendarComponent({
  isCalendarOpen,
  setIsCalendarOpen,
  provideIdAv,
  showAlert,
  isModal = true,
  isMultiDayAvailability = false,
  // provider = null,
  providerWeeklyAvailability = null,
  providerDefaultZones = null,
  leaves = null,
  dayPreferences = null,
  upsertProviderConstraint,
  setDayPreferences,
  workingDays,
  providerTimezone,
  weeklyDateRanges,
  selectedWeeklyDateRange,
  getWeeklyDateRanges,
  marketId,
  markets
}) {
  const user = useSelector(selectUser);

  const [events, setEvents] = useState([
    {
      id: 1,
      title: "Booked",
      start: new Date(2024, 8, 3),
      end: new Date(2024, 8, 7),
    },
  ]);

  const [selectedRange, setSelectedRange] = useState(null);
  const [eventTitle, setEventTitle] = useState("");
  const [value, setValue] = useState(dayjs());
  const [calendarOpenStart, setCalendarOpenStart] = useState(false);
  const [timePickerOpenStart, setTimePickerOpenStart] = useState(false);
  const calendarRefStart = React.useRef(null);
  const timePickerRefStart = React.useRef(null);
  const [calendarOpenEnd, setCalendarOpenEnd] = useState(false);
  const [timePickerOpenEnd, setTimePickerOpenEnd] = useState(false);
  const calendarRefEnd = React.useRef(null);
  const timePickerRefEnd = React.useRef(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isEventModalOpen, setIsEventModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [eventDetails, setEventDetails] = useState([]);
  const [newRange, setNewRange] = useState(null);
  const [providerAv, setProviderAv] = useState([]);
  const [apiData, setApiData] = useState([]);
  const today = new Date();
  // const today = new Date(2024, 8, 26);
  const startOfYear = new Date(today.getFullYear(), 0, 1);
  const endOfYear = new Date(today.getFullYear(), 11, 31);
  const [isTemporary, setIsTemporary] = useState(true);
  const [daysSelected, setDaysSelected] = useState(days.map(({ id }) => id));
  const [getProviderAvailability] = useGetProviderAvailabilityMutation();
  const availabilityRequestId = React.useRef(0);
  const [upsertProviderAvailability] = useUpsertProviderAvailabilityMutation();
  const [isEdited, setIsEdited] = useState({ status: false, oldName: "" });
  const [isDelete, setIsDelete] = useState(false);
  const [isTimeSlotSelect, setIsTimeSlotSelect] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isMultiDayAvailabilityModalOpen, setIsMultiDayAvailabilityModalOpen] =
    useState(false);
  const [selectedApplyToDays, setSelectedApplyToDays] = useState(
    applyToDays.map(({ id }) => id)
  );
  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const [zones, setZones] = useState([]);
  const [zipCodes, setZipCodes] = useState([]);
  const [selectedTab, setSelectedTab] = useState("zip");
  const [selectedCoverage, setSelectedCoverage] = useState("default");
  const [selectedStartTime, setSelectedStartTime] = useState("09:00");
  const [selectedEndTime, setSelectedEndTime] = useState("17:00");
  const [selectedAppointmentTypes, setSelectedAppointmentTypes] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [selectedZipCodes, setSelectedZipCodes] = useState([]);
  const allZipCodes = new Set();
  const flattenZipCodes = (data) => {
    data.forEach((item) => {
      if (item.zipCode) {
        allZipCodes.add(item.zipCode);
      }
      if (item.cities) {
        flattenZipCodes(item.cities);
      }
      if (item.counties) {
        flattenZipCodes(item.counties);
      }
    });
  };

  const [defaultGeographicCoverage, setDefaultGeographicCoverage] =
    useState(true);
  const [regularDailySettings, setRegularDailySettings] = useState(false);
  const [eventAvailabilityType, setEventAvailabilityType] =
    useState("singleDay");
  const [isLeaveModalOpen, setIsLeaveModalOpen] = useState(false);
  const [providerEv, setProviderEv] = useState([]);
  const [updateWeeklySettings, setUpdateWeeklySettings] = useState(false);
  const [isEditConfirmationModalOpen, setIsEditConfirmationModalOpen] =
    useState(false);

  const [isConfModalOpen, setIsConfModalOpen] = React.useState({ status: false, message: "" });
  const [isSaveConfirmationModalOpen, setIsSaveConfirmationModalOpen] = useState({ status: false, message: '', isWeeklyEv: false });
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedSections, setExpandedSections] = useState(new Set());
  const [coverageData, setCoverageData] = useState([]);
  flattenZipCodes(coverageData);
  const [isLoading, setIsLoading] = useState(true);
  const [showZipModal, setShowZipModal] = React.useState({ status: false, zips: [] });

  const handleSelectAll = (isChecked) => {
    const newZipCodes = isChecked ? Array.from(allZipCodes) : [];
    setSelectedZipCodes(newZipCodes);

    // setDayPreferences((prev) => ({
    //   ...prev,
    //   [selectedDay]: {
    //     ...prev?.[selectedDay],
    //     zip_codes: newZipCodes,
    //     zone_ids: [], // Clear zones when using zip codes
    //   },
    // }));
  };

  const isAllSelected =
    allZipCodes.size > 0 && selectedZipCodes.length === allZipCodes.size;
  const isSomeSelected =
    selectedZipCodes.length > 0 && selectedZipCodes.length < allZipCodes.size;


  const estTimezone = "America/New_York";

  const eightWeeksFromToday = new Date(today);
  eightWeeksFromToday.setDate(today.getDate() + 56); // 8 weeks later

  const [fetchZones] = useFetchZonesMutation();

  const getZones = async () => {
    try {
      const { data: response } = await fetchZones().unwrap();
      setZones(response);
      setZipCodes([...new Set(response.flatMap((e) => e.zip_codes))]);
    } catch (error) {
      console.log(error);
    }
  };

  const [fetchAppointmentTypes] = useFetchAppointmentTypesMutation();
  const [fetchProviderZipCodes] = useFetchProviderZipCodesMutation();
  const [validateDeletedDates] = useValidateDeletedDatesMutation();

  const getAppointmentTypes = async () => {
    try {
      const { data: response } = await fetchAppointmentTypes({
        organisationId: user.organisation.id,
        rotation: "all",
        format: "all",
        dispatch: "all",
        screen: "provider_settings",
      }).unwrap();

      setAppointmentTypes(response.appointmentTypes);
    } catch (error) {
      console.log(error);
    }
  };
  const getZipCodes = async () => {

    try {
      setIsLoading(true);
      const { data } = await fetchProviderZipCodes({ providerId: provideIdAv, marketId }).unwrap();
      setCoverageData(data || []);
    } catch (error) {
      console.error("Error fetching coverage data:", error);
      setCoverageData([]);
    } finally {
      setIsLoading(false);
    }


  };

  const filteredData = (data) => {
    return data.filter((item) => {
      // City level (has zipCode)
      if (item.zipCode) {
        return (
          item.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.zipCode.includes(searchTerm)
        );
      }

      // County level (has cities)
      if (item.cities) {
        const hasMatchingCities = filteredData(item.cities).length > 0;
        return (
          item.county.toLowerCase().includes(searchTerm.toLowerCase()) ||
          hasMatchingCities
        );
      }

      // State level (has counties)
      if (item.counties) {
        const hasMatchingCounties = filteredData(item.counties).length > 0;
        return (
          item.state.toLowerCase().includes(searchTerm.toLowerCase()) ||
          hasMatchingCounties
        );
      }

      return false;
    });
  };
  const handleBulkZipCodeToggle = (zipCodes, isChecked) => {
    const selectedDay = new Date(selectedRange?.start)
      .toLocaleString('en-US', { weekday: 'long' })
      .toUpperCase() || "ALL"
    // setDayPreferences((prev) => {
    const prevZipCodes = selectedZipCodes || [];
    let newZipCodes;

    if (isChecked) {
      // Add all zip codes that aren't already selected
      const zipCodesSet = new Set(prevZipCodes);
      zipCodes.forEach((zip) => zipCodesSet.add(zip));
      newZipCodes = Array.from(zipCodesSet);
    } else {
      // Remove all the zip codes
      const zipCodesToRemove = new Set(zipCodes);
      newZipCodes = prevZipCodes.filter((zip) => !zipCodesToRemove.has(zip));
    }
    setSelectedZipCodes(newZipCodes)

    // return {
    //   ...prev,
    //   [selectedDay]: {
    //     ...prev?.[selectedDay],
    //     zip_codes: newZipCodes,
    //     zone_ids: [], // Clear zones when using zip codes
    //   },
    // };
    // });
  };
  const handleZipCodeToggle = (zipCode, isChecked) => {
    const selectedDay = new Date(selectedRange?.start)
      .toLocaleString('en-US', { weekday: 'long' })
      .toUpperCase() || "ALL"
    // setDayPreferences((prev) => {
    const prevZipCodes = selectedZipCodes || [];
    let newZipCodes;

    if (isChecked) {
      // Only add if not already present
      if (!prevZipCodes.includes(zipCode)) {
        newZipCodes = [...prevZipCodes, zipCode];
      } else {
        newZipCodes = prevZipCodes;
      }
    } else {
      newZipCodes = prevZipCodes.filter((zip) => zip !== zipCode);
    }
    setSelectedZipCodes(newZipCodes)
    // return {
    //   ...prev,
    //   [selectedDay]: {
    //     ...prev?.[selectedDay],
    //     zip_codes: newZipCodes,
    //     zone_ids: [], // Clear zones when using zip codes
    //   },
    // };
    // });
  };
  const toggleSection = (sectionId) => {
    setExpandedSections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(sectionId)) {
        newSet.delete(sectionId);
      } else {
        newSet.add(sectionId);
      }
      return newSet;
    });
  };
  const renderTreeItem = (item, level = 1) => {

    // Get unique ID based on item type
    const itemId = item.zipCode || item.county || item.state;
    const isExpanded = expandedSections.has(itemId);
    const hasChildren =
      (item.counties && item.counties.length > 0) ||
      (item.cities && item.cities.length > 0);

    if (item.zipCode) {
      // City/Zip code level
      const isSelected = selectedZipCodes.includes(item.zipCode);

      return (
        <div
          key={item.zipCode}
          className={`border-b border-gray-100 last:border-b-0 ${level === 3
            ? "bg-gray-50 border-l-4 border-gray-300"
            : level === 2
              ? "bg-white border-l-2 border-gray-200"
              : "bg-gray-100"
            }`}
        >
          <div className="flex gap-2 items-center px-3 py-2 transition-colors cursor-default hover:bg-blue-50">
            <span className="w-4 h-4"></span>
            <input
              type="checkbox"
              disabled={
                !user?.permissions?.includes(
                  "provider_settings.edit_weekly_settings"
                )
              }
              className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
              checked={isSelected}
              onChange={(e) =>
                handleZipCodeToggle(item.zipCode, e.target.checked)
              }
            />
            <span
              className={`flex-1 ${level === 3
                ? "text-gray-600 text-sm"
                : level === 2
                  ? "text-gray-700"
                  : "text-gray-900 font-medium"
                }`}
            >
              {item.city}
            </span>
            <span className="px-2 py-1 text-xs font-medium text-blue-800 bg-blue-100 rounded">
              {item.zipCode}
            </span>
          </div>
        </div>
      );
    } else {
      // State or County level
      const childZips = getAllChildZipCodes(item);
      const selectedChildCount = childZips.filter((zip) =>
        selectedZipCodes.includes(zip)
      ).length;
      const isAllChildrenSelected =
        childZips.length > 0 && selectedChildCount === childZips.length;
      const isSomeChildrenSelected =
        selectedChildCount > 0 && selectedChildCount < childZips.length;

      const itemName = item.state || item.county;
      const children = item.counties || item.cities;

      return (
        <div
          key={itemId}
          className={`border-b border-gray-200 last:border-b-0 ${level === 1 ? "bg-gray-100" : "bg-white"
            }`}
        >
          <div
            className={`flex items-center gap-2 px-3 py-2 ${hasChildren ? "cursor-pointer hover:bg-blue-50" : "cursor-default"
              } transition-colors`}
            onClick={() => hasChildren && toggleSection(itemId)}
          >
            {hasChildren && (
              <span
                className={`w-4 h-4 flex items-center justify-center text-gray-500 transition-transform ${isExpanded ? "rotate-90" : ""}`}
              >
                ▶
              </span>
            )}
            {!hasChildren && <span className="w-4 h-4"></span>}
            <input
              type="checkbox"
              disabled={
                !user?.permissions?.includes(
                  "provider_settings.edit_weekly_settings"
                )
              }
              className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
              checked={isAllChildrenSelected}
              ref={(el) => {
                if (el) {
                  el.indeterminate = isSomeChildrenSelected;
                }
              }}
              onChange={(e) => {
                handleBulkZipCodeToggle(childZips, e.target.checked);
              }}
              onClick={(e) => e.stopPropagation()}
            />
            <span
              className={`flex-1 ${level === 1 ? "text-gray-900 font-medium" : "text-gray-700"
                }`}
            >
              {itemName}
            </span>
            {item.zipCount && (
              <span className="px-2 py-1 text-xs font-medium text-gray-700 bg-gray-200 rounded">
                {item.zipCount} zip codes
              </span>
            )}
          </div>

          {hasChildren && isExpanded && (
            <div className="ml-4 border-l border-gray-200">
              {filteredData(children).map((child) =>
                renderTreeItem(child, level + 1)
              )}
            </div>
          )}
        </div>
      );
    }
  };

  const getAllChildZipCodes = (item) => {
    const zips = [];
    if (item.zipCode) {
      zips.push(item.zipCode);
    }
    if (item.cities) {
      item.cities.forEach((child) => {
        zips.push(...getAllChildZipCodes(child));
      });
    }
    if (item.counties) {
      item.counties.forEach((child) => {
        zips.push(...getAllChildZipCodes(child));
      });
    }
    return zips;
  };


  const handleNavigate = (newDate, view) => {
    if (view === "month") {
      setCurrentDate(newDate);
    }
  };

  const isWithinAllowedRange = (date) => {
    const isToday = moment(date).isSame(moment(today), "day");
    return (
      isToday ||
      (moment(date).isAfter(today) &&
        moment(date).isSameOrBefore(eightWeeksFromToday))
    );
  };
  const isEditableToShow =
    selectedEvent && isWithinAllowedRange(selectedEvent.start);

  const handleSelectSlot = ({ start, end }) => {
    if (marketId === 'ALL') {
      return;
    }
    if (new Date(start) < new Date()) {
      return; // block selection
    }
    if (!user?.permissions?.includes('provider_settings.edit_calendar_view_settings')) {
      return;
    }
    const today = new Date();
    if (moment(start).isBefore(moment(today), "day")) {
      return;
    }


    const localStart = new Date(start);
    localStart.setHours(0, 0, 0, 0);

    const localEnd = new Date(end);
    if (
      localEnd.getHours() === 0 &&
      localEnd.getMinutes() === 0 &&
      localEnd.getSeconds() === 0
    ) {
      localEnd.setDate(localEnd.getDate() - 1);
    }
    localEnd.setHours(23, 59, 59, 999);

    // Compare dates using moment's isSame with 'day' unit
    if (!moment(localStart).isSame(moment(localEnd), "day")) {
      showAlert("You can't select multiple dates.", "info");
      return;
    }

    const isLeaveDay = mergedEvents.some(event =>
      event.isLeave &&
      moment(localStart).isBetween(moment(event.start), moment(event.end), "day", "[]") // inclusive check
    );
    if (isLeaveDay) {
      return;
    }
    // if (!isWithinAllowedRange(localStart)) {
    //   showAlert("You can't select dates because it's out of range.", "info");
    //   return;
    // }

    setIsTimeSlotSelect(true);
    const existingEvents = providerAv.filter((event) => {
      const eventStart = moment(event.start).startOf("day");
      const eventEnd = moment(event.end).endOf("day");
      return (
        eventStart.isSameOrBefore(moment(localEnd).endOf("day")) &&
        eventEnd.isSameOrAfter(moment(localStart).startOf("day"))
      );
    });

    if (existingEvents.length > 0) {
      setEventDetails(existingEvents);
      setNewRange({ start: localStart, end: localEnd });
      setIsConfirmationModalOpen(true);
    } else {
      setSelectedRange({ start: localStart, end: localEnd });
      if (!isMultiDayAvailability) {
        setIsCalendarOpen(true);
      } else {
        setSelectedEvent(null);
        setSelectedAppointmentTypes([]);
        setSelectedZipCodes([]);
        setSelectedZones(providerDefaultZones || []);
        setRegularDailySettings(false);
        setIsMultiDayAvailabilityModalOpen(true);
      }
    }
  };
  const closeModal = (obj) => {
    if (obj.isClearAll) {
      setIsCalendarOpen(false);
    }
    setSelectedRange(null);
    setEventTitle("");
    setIsEdited({ status: false });
    setIsTimeSlotSelect(false);
  };
  const getDateAfterTwoMonths = (currentDate) => {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + 55);
    return date;
  };
  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  function getDatesFromRange(start, end, daysSelected) {
    const startDate = new Date(start); // Convert start string to Date object
    const endDate = new Date(end); // Convert end string to Date object

    const dates = [];
    let currentDate = new Date(startDate); // Clone the start date

    while (currentDate <= endDate) {
      const day = moment(currentDate).get("day");
      if (daysSelected.includes(day)) {
        dates.push(new Date(currentDate)); // Push the current date to the array
      }
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    }
    return dates;
  }
  function getWeekNumberFromDate(date, startDate) {
    const oneDay = 1000 * 60 * 60 * 24; // Milliseconds in one day
    const diffInDays = Math.floor((date - startDate) / oneDay);

    const weekNumber = Math.floor(diffInDays / 7) + 1; // Week numbers start from 1

    const weekStartDate = new Date(
      startDate.getTime() + (weekNumber - 1) * 7 * oneDay
    );
    const weekEndDate = new Date(weekStartDate.getTime() + 6 * oneDay);

    if (date >= weekStartDate && date <= weekEndDate) {
      return weekNumber; // Return the week number if the date is in the range
    }

    return weekNumber + 1; // Otherwise, it belongs to the next week
  }

  function addDatesToList(selectedDates, dates) {
    selectedDates.forEach((selectedDate) => {
      const defaultTimeSlots = `${moment(selectedRange.start).format(
        "HH:mm"
      )}-${moment(selectedRange.end).format("HH:mm")}`;
      let dateTimeSlots;
      const isSingleDate = selectedDates.length === 1;
      if (isSingleDate) {
        dateTimeSlots = `${moment(selectedRange.start).format(
          "HH:mm"
        )}-${moment(selectedRange.end).format("HH:mm")}`;
      } else {
        dateTimeSlots = defaultTimeSlots;
      }
      dates.push({
        date: formatDateToYYYYMMDD(selectedDate),
        time_slots: [dateTimeSlots],
        // title: `${dateTimeSlots[0]}-${dateTimeSlots[1]}`,
      });
    });

    return dates;
  }

  const confirmBooking = async () => {
    if (daysSelected.length === 0) {
      showAlert("Please select the available days.", "info");
      return;
    }

    const getUpdatedBooking = (data) => {
      const weekStart = new Date(data?.[0]?.date);
      const weekEnd = new Date(data?.[data.length - 1]?.date);

      weekStart.setHours(0, 0, 0, 0);
      weekEnd.setHours(23, 59, 59, 999);
      function timeStringToSeconds(timeString) {
        const [hours, minutes] = timeString.split(":").map(Number);
        return hours * 3600 + minutes * 60;
      }
      function doTimeSlotsOverlap(start1, end1, start2, end2) {
        return (
          (start1 < end2 && start2 < end1) ||
          (start1 === start2 && end1 === end2)
        );
      }
      function isTimeSlotAvailable(
        date,
        newStartTime,
        newEndTime,
        existingBookings
      ) {
        const newStartInSeconds = timeStringToSeconds(newStartTime);
        const newEndInSeconds = timeStringToSeconds(newEndTime);

        for (const booking of existingBookings) {
          if (booking.date === date) {
            const [start, end] = booking.time_slots?.[0]?.split("-") || [];
            const existingStartInSeconds = timeStringToSeconds(start);
            const existingEndInSeconds = timeStringToSeconds(end);

            if (
              doTimeSlotsOverlap(
                newStartInSeconds,
                newEndInSeconds,
                existingStartInSeconds,
                existingEndInSeconds
              )
            ) {
              return false; // Overlap found, time slot is not available
            }
          }
        }
        return true; // No overlap found, time slot is available
      }

      const datesInRange = [];
      const effectiveStart = selectedRange.start;
      const effectiveEnd = selectedRange.end;
      const isSingleDay =
        selectedRange.start.toDateString() === selectedRange.end.toDateString();

      const singleDayTimeSlot = [
        `${moment(selectedRange.start).format("HH:mm")}-${moment(
          selectedRange.end
        ).format("HH:mm")}`,
      ];

      for (
        let d = new Date(effectiveStart);
        d <= effectiveEnd;
        d.setDate(d.getDate() + 1)
      ) {
        const existingBookings = data;
        const dateToBook =
          d.getFullYear() +
          "-" +
          String(d.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(d.getDate()).padStart(2, "0");
        const desiredStartTime = moment(selectedRange.start).format("HH:mm");
        const desiredEndTime = moment(selectedRange.end).format("HH:mm");
        if (
          isTimeSlotAvailable(
            dateToBook,
            desiredStartTime,
            desiredEndTime,
            existingBookings
          ) ||
          isEdited?.status == true ||
          isDelete
        ) {
          datesInRange.push({
            date: dateToBook,
            time_slots:
              isSingleDay &&
                d.toDateString() === selectedRange.start.toDateString()
                ? singleDayTimeSlot
                : singleDayTimeSlot,
          });
        } else {
          showAlert(
            "The selected time slot is already booked. Please choose a different time slot.",
            "info"
          );
          return;
        }
      }
      return datesInRange;
    };

    if (apiData.length <= 0) {
      const dates = [];

      const selectedDates = getDatesFromRange(
        selectedRange?.start,
        selectedRange?.end,
        daysSelected
      );

      addDatesToList(selectedDates, dates);

      const groupDates = groupAppointmentsByDate(dates);

      await upsertProviderAvailability({
        data: {
          availabilities: Object.keys(groupDates).map((key) => {
            return {
              indexDate: key,
              availability: groupDates[key],
              marketId
            };
          }),
        },
        id: provideIdAv,
      });
    } else {
      const overlappingWeeksWithDates = getUpdatedBooking(apiData);

      if (isDelete === true) {
        const existingDates = apiData;
        const dateToDelete = overlappingWeeksWithDates[0];
        const time_slots = dateToDelete?.time_slots?.[0]?.split("-");
        const newDates = existingDates
          ?.map((item) => {
            if (
              item?.dates?.length === 1 &&
              item?.dates[0] === dateToDelete?.date &&
              item?.working_hours?.start_time === time_slots[0] &&
              item?.working_hours?.end_time === time_slots[1]
            )
              return undefined;
            const dates = item?.dates.filter(
              (date) =>
                date !== dateToDelete?.date ||
                item?.working_hours?.start_time !== time_slots[0] ||
                item?.working_hours?.end_time !== time_slots[1]
            );
            return {
              ...item,
              dates,
              date_range: {
                start_date: dates[0],
                end_date: dates[dates.length - 1],
              },
            };
          })
          .filter(Boolean);

        const consecutiveDates = splitAllConsecutiveDateGroups(newDates);
        const groupDates = groupAppointmentsByDate(consecutiveDates);
        overlappingWeeksWithDates?.length > 0 &&
          (await upsertProviderAvailability({
            id: provideIdAv,
            data: {
              availabilities: Object.keys(groupDates).map((key) => {
                return {
                  indexDate: key,
                  availability: groupDates[key],
                  marketId
                };
              }),
            },
          }).unwrap());
        setIsDelete(false);
      } else {
        const existingDates = apiData;
        // Fetch current available dates
        const newDates = overlappingWeeksWithDates.map((dateItem) => ({
          date: dateItem.date,
          time_slots: dateItem?.time_slots,
        }));
        // Merge existing and new dates without duplicates
        const mergedDates = [
          ...(isEdited?.status == true
            ? existingDates.filter(
              (existing) =>
                !newDates.some(
                  (newDate) =>
                    newDate.date === existing.date &&
                    isEdited?.oldName === existing?.time_slots[0]
                )
            )
            : existingDates),
          ...newDates,
        ];
        const groupDates = groupAppointmentsByDate(mergedDates);
        overlappingWeeksWithDates?.length > 0 &&
          (await upsertProviderAvailability({
            id: provideIdAv,
            data: {
              availabilities: Object.keys(groupDates).map((key) => {
                return {
                  indexDate: key,
                  availability: groupDates[key],
                  marketId
                };
              }),
            },
          }).unwrap());
      }
    }
    // Fetch updated availability after all updates are done
    await getProviderAvailabilityFun();
    setIsEdited(false);
    setDaysSelected(days.map(({ id }) => id));
    closeModal({ isClearAll: false });
  };

  const saveMultiDayAvailability = async (force) => {
    // if (isWeeklyEv) {
    //   const startDate = moment(selectedRange.start);
    //   const endDate = moment(selectedRange.end);
    //   // selectedApplyToDays might contain something like ['Friday']
    //   const selectedDayNames = applyToDays
    //     .filter(({ id }) => selectedApplyToDays.includes(id))
    //     .map(({ name }) => name); // e.g. ['Friday']
    //   // Generate all dates in range that match selected days
    //   const matchedDates = [];
    //   const dayName = selectedEvent?.day?.toUpperCase();
    //   for (let d = startDate.clone(); d.isSameOrBefore(endDate, "day"); d.add(1, "day")) {

    //     const currentDay = d.format("dddd").toUpperCase(); // e.g. "SATURDAY"

    //     // include only if this date matches one of the selected days
    //     if ([dayName].includes(currentDay)) {
    //       matchedDates.push(d.format("YYYY-MM-DD"));
    //     }
    //   }
    //   if (matchedDates.length === 0) {
    //     showAlert("No matching days found in the selected range.", "info");
    //     return;
    //   }



    //   // Build the new availability data for these matched dates
    //   const overlappingAvailabilities = apiData?.filter((a) =>
    //     a.dates?.some((date) => matchedDates.includes(date))
    //   );

    //   let mergedAvailabilityData = [];

    //   const overlappingWeeksWithDates =
    //     apiData?.filter((a) => a.dates?.some((d) => matchedDates.includes(d))) || [];

    //   if (isDelete === true) {
    //     // 🔹 Delete overlapping weekly availability
    //     const existingDates = apiData;
    //     const datesToDelete = overlappingWeeksWithDates;

    //     const time_slots = datesToDelete?.[0]?.time_slots?.[0]?.split("-");
    //     const newDates = existingDates
    //       ?.map((item) => {
    //         const dates_to_delete = datesToDelete?.map((date) => date?.date);
    //         const dates = item?.dates.filter(
    //           (date) =>
    //             !dates_to_delete?.includes(date) ||
    //             item?.working_hours?.start_time !== time_slots?.[0] ||
    //             item?.working_hours?.end_time !== time_slots?.[1]
    //         );
    //         return dates?.length
    //           ? {
    //             ...item,
    //             dates,
    //             date_range: {
    //               start_date: dates[0],
    //               end_date: dates[dates.length - 1],
    //             },
    //           }
    //           : undefined;
    //       })
    //       .filter(Boolean);

    //     const consecutiveDates = splitAllConsecutiveDateGroups(newDates);
    //     let groupDates = groupAppointmentsByDate(consecutiveDates);

    //     if (JSON.stringify(groupDates) === "{}" && datesToDelete?.length) {
    //       const key = moment(datesToDelete[0]?.date)
    //         .startOf("month")
    //         .format("YYYY-MM-DD");
    //       groupDates = { [key]: [] };
    //     }

    //     // ✅ only apply for weekly event deletion
    //     if (overlappingWeeksWithDates?.length > 0 && selectedEvent?.isWeeklyEv) {
    //       await upsertProviderAvailability({
    //         id: provideIdAv,
    //         data: {
    //           availabilities: Object.keys(groupDates).map((key) => ({
    //             indexDate: key,
    //             availability: groupDates[key],
    //           })),
    //         },
    //       }).unwrap();
    //     }
    //     setIsDelete(false);
    //   } else {
    //     // 🔹 Add or update weekly availability
    //     if (overlappingWeeksWithDates?.length) {
    //       const selectedDates = matchedDates;

    //       // Check if a single-day availability already exists
    //       const singleDay = apiData.find(
    //         (a) => a.dates.length === 1 && selectedDates.length === 1 && a.dates[0] === selectedDates[0]
    //       );

    //       let availabilityData = [];
    //       if (singleDay) {
    //         // 🧩 Update existing single-day
    //         availabilityData = apiData.map((api) => {
    //           if (api.dates.length === 1 && api.dates[0] === selectedDates[0]) {
    //             return {
    //               ...api,
    //               working_hours: {
    //                 start_time: getEstTimezoneTime(
    //                   selectedDates[0],
    //                   selectedStartTime,
    //                   providerTimezone
    //                 ),
    //                 end_time: getEstTimezoneTime(
    //                   selectedDates[0],
    //                   selectedEndTime,
    //                   providerTimezone
    //                 ),
    //               },
    //               appointment_type_ids: selectedAppointmentTypes || [],
    //               zone_ids: selectedZones || [],
    //               zip_codes: selectedZipCodes || [],
    //             };
    //           }
    //           return api;
    //         });
    //       } else {
    //         // 🧩 Merge with existing or add new
    //         const newDates = apiData
    //           ?.map((item) => {
    //             const dates = item?.dates.filter((date) => !selectedDates.includes(date));
    //             if (!dates.length) return undefined;
    //             return {
    //               ...item,
    //               dates,
    //               date_range: {
    //                 start_date: dates[0],
    //                 end_date: dates[dates.length - 1],
    //               },
    //             };
    //           })
    //           .filter(Boolean);

    //         const consecutiveDates = splitAllConsecutiveDateGroups(newDates);
    //         availabilityData = [...consecutiveDates];

    //         const isSameEventExists = consecutiveDates.find((availability) => {
    //           const sameTypes = areEqualArrays(
    //             availability?.appointment_type_ids,
    //             selectedAppointmentTypes
    //           );
    //           const sameZones = areEqualArrays(availability?.zone_ids, selectedZones);
    //           const sameZip = areEqualArrays(availability?.zip_codes, selectedZipCodes);
    //           const sameTime =
    //             availability?.working_hours?.start_time === selectedStartTime &&
    //             availability?.working_hours?.end_time === selectedEndTime;
    //           return (
    //             availability?.dates?.some((d) => selectedDates.includes(d)) &&
    //             sameTypes &&
    //             sameZones &&
    //             sameZip &&
    //             sameTime
    //           );
    //         });

    //         if (!isSameEventExists) {
    //           availabilityData.push({
    //             date_range: {
    //               start_date: moment(selectedRange.start).format("YYYY-MM-DD"),
    //               end_date: moment(selectedRange.end).format("YYYY-MM-DD"),
    //             },
    //             dates: matchedDates,
    //             working_days: selectedDayNames,
    //             working_hours: {
    //               start_time: getEstTimezoneTime(
    //                 moment(selectedRange.start).format("YYYY-MM-DD"),
    //                 selectedStartTime,
    //                 providerTimezone
    //               ),
    //               end_time: getEstTimezoneTime(
    //                 moment(selectedRange.end).format("YYYY-MM-DD"),
    //                 selectedEndTime,
    //                 providerTimezone
    //               ),
    //             },
    //             appointment_type_ids: selectedAppointmentTypes || [],
    //             zone_ids: selectedZones || [],
    //             zip_codes: selectedZipCodes || [],
    //             isWeeklyEv: false,
    //           });
    //         }
    //       }

    //       const availabilities = [
    //         {
    //           indexDate: startDate.startOf("month").format("YYYY-MM-DD"),
    //           availability: availabilityData,
    //         },
    //       ];
    //       await upsertProviderAvailability({
    //         id: provideIdAv,
    //         data: { availabilities },
    //       }).unwrap();
    //     } else {
    //       if (!apiData || apiData.length === 0) {
    //         const newAvailability = {
    //           indexDate: startDate.startOf("month").format("YYYY-MM-DD"),
    //           availability: [
    //             {
    //               date_range: {
    //                 start_date: startDate.format("YYYY-MM-DD"),
    //                 end_date: endDate.format("YYYY-MM-DD"),
    //               },
    //               dates: matchedDates,
    //               working_days: selectedDayNames,
    //               working_hours: {
    //                 start_time: getEstTimezoneTime(
    //                   startDate.format("YYYY-MM-DD"),
    //                   selectedStartTime,
    //                   providerTimezone
    //                 ),
    //                 end_time: getEstTimezoneTime(
    //                   endDate.format("YYYY-MM-DD"),
    //                   selectedEndTime,
    //                   providerTimezone
    //                 ),
    //               },
    //               appointment_type_ids: selectedAppointmentTypes || [],
    //               zone_ids: selectedZones || [],
    //               zip_codes: selectedZipCodes || [],
    //               isWeeklyEv: false,
    //             },
    //           ],
    //         };

    //         await upsertProviderAvailability({
    //           id: provideIdAv,
    //           data: {
    //             availabilities: [newAvailability],
    //           },
    //         }).unwrap();

    //         // Refresh UI
    //         await getProviderAvailabilityFun({
    //           startDate: moment(currentDate).startOf("month").format("YYYY-MM-DD"),
    //           endDate: moment(currentDate)
    //             .add(1, "months")
    //             .startOf("month")
    //             .format("YYYY-MM-DD"),
    //         });

    //         setIsMultiDayAvailabilityModalOpen(false);
    //         setIsEdited(false);
    //         setDaysSelected(applyToDays.map(({ id }) => id));
    //         closeModal({ isClearAll: false });
    //         return;
    //       } else {
    //         const newAvailability = {
    //           indexDate: startDate.startOf("month").format("YYYY-MM-DD"),
    //           availability: [
    //             {
    //               date_range: {
    //                 start_date: startDate.format("YYYY-MM-DD"),
    //                 end_date: endDate.format("YYYY-MM-DD"),
    //               },
    //               dates: matchedDates,
    //               working_days: selectedDayNames,
    //               working_hours: {
    //                 start_time: getEstTimezoneTime(
    //                   startDate.format("YYYY-MM-DD"),
    //                   selectedStartTime,
    //                   providerTimezone
    //                 ),
    //                 end_time: getEstTimezoneTime(
    //                   endDate.format("YYYY-MM-DD"),
    //                   selectedEndTime,
    //                   providerTimezone
    //                 ),
    //               },
    //               appointment_type_ids: selectedAppointmentTypes || [],
    //               zone_ids: selectedZones || [],
    //               zip_codes: selectedZipCodes || [],
    //               isWeeklyEv: false,
    //             },
    //           ],
    //         };

    //         await upsertProviderAvailability({
    //           id: provideIdAv,
    //           data: {
    //             availabilities: [
    //               ...apiData.map((item) => ({
    //                 indexDate: item.indexDate || startDate.startOf("month").format("YYYY-MM-DD"),
    //                 availability: item.availability || [],
    //               })),
    //               newAvailability, // append new block
    //             ],
    //           },
    //         }).unwrap();
    //       }
    //     }
    //   }

    //   // ✅ STEP 5: Refresh and reset UI
    //   await getProviderAvailabilityFun({
    //     startDate: moment(currentDate).startOf("month").format("YYYY-MM-DD"),
    //     endDate: moment(currentDate).add(1, "months").startOf("month").format("YYYY-MM-DD"),
    //   });

    //   setIsMultiDayAvailabilityModalOpen(false);
    //   setIsEdited(false);
    //   setDaysSelected(applyToDays.map(({ id }) => id));
    //   closeModal({ isClearAll: false });
    //   return;
    // }
    setIsConfModalOpen({ status: false, message: null })
    if (selectedApplyToDays.length === 0) {
      showAlert("Please select the available days.", "info");
      return;
    }

    const startT = moment(selectedStartTime, "HH:mm");
    const endT = moment(selectedEndTime, "HH:mm");

    if (startT.isAfter(endT)) {
      showAlert("Start time cannot be after end time.", "error");
      return;
    }

    const getMultiDayUpdatedBooking = (data) => {
      const weekStart = new Date(selectedRange.start);
      weekStart.setHours(0, 0, 0, 0);

      const weekEnd = new Date(selectedRange.end);
      weekEnd.setHours(23, 59, 59, 999);

      function timeStringToSeconds(timeString) {
        const [hours, minutes] = timeString.split(":").map(Number);
        return hours * 3600 + minutes * 60;
      }
      function doTimeSlotsOverlap(start1, end1, start2, end2) {
        return (
          (start1 < end2 && start2 < end1) ||
          (start1 === start2 && end1 === end2)
        );
      }
      const [editedStart, editedEnd] =
        (isEdited?.oldName || eventTitle)?.split("-") || [];
      const isBookingBeingEdited = (booking) =>
        isEdited?.status === true &&
        Boolean(editedStart && editedEnd) &&
        templateIdMatch(booking) &&
        normalizeTimeToHHmm(booking?.start) === normalizeTimeToHHmm(editedStart) &&
        normalizeTimeToHHmm(booking?.end) === normalizeTimeToHHmm(editedEnd);

      function isTimeSlotAvailable(
        date,
        newStartTime,
        newEndTime,
        existingBookings
      ) {
        const newStartInSeconds = timeStringToSeconds(newStartTime);
        const newEndInSeconds = timeStringToSeconds(newEndTime);
        const bookings = existingBookings.flatMap((e) => {
          const { dates, working_hours } = e;
          const { start_time, end_time } = working_hours;

          return dates.map((date) => ({
            date,
            start: start_time,
            end: end_time,
            template_id: e?.template_id,
          }));
        });

        existingBookings = bookings;

        for (const booking of existingBookings) {
          if (booking.date === date) {
            // The block being edited would always clash with itself
            if (isBookingBeingEdited(booking)) {
              continue;
            }
            const { start, end } = booking || {};
            const existingStartInSeconds = timeStringToSeconds(start);
            const existingEndInSeconds = timeStringToSeconds(end);

            if (
              doTimeSlotsOverlap(
                newStartInSeconds,
                newEndInSeconds,
                existingStartInSeconds,
                existingEndInSeconds
              )
            ) {
              return false;
            }
          }
        }
        return true;
      }

      const datesInRange = [];
      const effectiveStart = weekStart;
      const effectiveEnd = weekEnd;
      const isSingleDay =
        effectiveStart.toDateString() === effectiveEnd.toDateString();

      const singleDayTimeSlot = [`${selectedStartTime}-${selectedEndTime}`];

      for (
        let d = new Date(effectiveStart);
        d <= effectiveEnd;
        d.setDate(d.getDate() + 1)
      ) {
        const existingBookings = data;
        const dateToBook = moment(d).format("YYYY-MM-DD");
        const desiredStartTime = selectedStartTime;
        const desiredEndTime = selectedEndTime;
        if (
          isTimeSlotAvailable(
            dateToBook,
            desiredStartTime,
            desiredEndTime,
            existingBookings
          ) ||
          isDelete
        ) {
          datesInRange.push({
            date: dateToBook,
            time_slots:
              isSingleDay && d.toDateString() === effectiveStart.toDateString()
                ? singleDayTimeSlot
                : singleDayTimeSlot,
          });
        } else {
          showAlert(
            "The selected time slot is already booked. Please choose a different time slot.",
            "info"
          );
          return;
        }
      }
      return datesInRange;
    };

    function areEqualArrays(a, b) {
      if (a?.length !== b?.length) return false;
      const sortedA = [...a].sort();
      const sortedB = [...b].sort();
      return sortedA.every((val, index) => val === sortedB[index]);
    }

    // Normalize time to HH:mm for reliable comparison (API may return "13:00:00")
    const normalizeTimeToHHmm = (t) => {
      if (!t) return t;
      const parts = String(t).trim().split(":");
      if (parts.length >= 2) return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}`;
      return t;
    };

    const templateIdMatch = (item) =>
      selectedEvent?.template_id == null ||
      item?.template_id === selectedEvent?.template_id;

    if (apiData?.length <= 0 && !(selectedEvent?.isWeeklyEv && isDelete)) {
      const availabilities = [];

      const selectedDates = getDatesFromRange(
        selectedRange?.start,
        selectedRange?.end,
        selectedApplyToDays
      );

      availabilities.push({
        indexDate: moment(selectedRange.start)
          .startOf("month")
          .format("YYYY-MM-DD"),
        availability: [
          {
            date_range: {
              start_date: moment(selectedRange.start).format("YYYY-MM-DD"),
              end_date: moment(selectedRange.end).format("YYYY-MM-DD"),
            },
            dates: selectedDates?.map((e) => moment(e).format("YYYY-MM-DD")),
            working_days: applyToDays
              .filter(({ id }) => selectedApplyToDays.includes(id))
              .map(({ name }) => name),
            working_hours: {
              start_time: selectedStartTime,
              end_time: selectedEndTime,
            },
            appointment_type_ids: selectedAppointmentTypes || [],
            zone_ids: selectedZones || [],
            zip_codes: selectedZipCodes || [],
            // isWeeklyEv: selectedEvent?.isWeeklyEv ? true : false,
            isWeeklyEv: false,
          },
        ],
      });

      const result = await upsertProviderAvailability({
        id: provideIdAv,

        data: {
          availabilities,
          force: true,
          marketId
        },
      });
      if (result?.data?.alert) {

        // showAlert(result?.data?.alert, "warning");
        setIsConfModalOpen({
          status: true,
          message: result?.data?.alert
        })
        return;
      }

    } else {
      const overlappingWeeksWithDates = getMultiDayUpdatedBooking(apiData);

      // Clash alert already shown, keep the modal open so the times can be corrected
      if (!overlappingWeeksWithDates) {
        return;
      }

      if (isDelete === true) {
        const existingDates = apiData;
        const datesToDelete = overlappingWeeksWithDates;
        const time_slots = datesToDelete?.[0]?.time_slots?.[0]?.split("-");

        const newDates = existingDates
          ?.map((item) => {
            if (
              item?.dates?.length === 1 &&
              datesToDelete?.length === 1 &&
              item?.dates[0] === datesToDelete?.[0]?.date &&
              templateIdMatch(item) &&
              normalizeTimeToHHmm(item?.working_hours?.start_time) === normalizeTimeToHHmm(time_slots?.[0]) &&
              normalizeTimeToHHmm(item?.working_hours?.end_time) === normalizeTimeToHHmm(time_slots?.[1])
            )
              return undefined;

            const dates_to_delete = datesToDelete?.map((date) => date?.date);
            // Only remove a date from this item if it matches the time slot and template we're deleting
            // (so other templates/time slots for the same date are preserved)
            const dates = item?.dates.filter(
              (date) =>
                !(
                  dates_to_delete?.includes(date) &&
                  templateIdMatch(item) &&
                  normalizeTimeToHHmm(item?.working_hours?.start_time) === normalizeTimeToHHmm(time_slots?.[0]) &&
                  normalizeTimeToHHmm(item?.working_hours?.end_time) === normalizeTimeToHHmm(time_slots?.[1])
                )
            );
            return {
              ...item,
              dates,
              date_range: {
                start_date: dates[0],
                end_date: dates[dates.length - 1],
              },
            };
          })
          .filter(Boolean);


        const consecutiveDates = splitAllConsecutiveDateGroups(newDates);


        let groupDates = groupAppointmentsByDate(consecutiveDates);


        if (JSON.stringify(groupDates) === "{}" && datesToDelete?.length) {
          const key = moment(datesToDelete[0]?.date).startOf("month").format("YYYY-MM-DD");
          groupDates = {
            [key]: [],
          };
        }

        if (overlappingWeeksWithDates?.length > 0) {
          // !selectedEvent?.isWeeklyEv &&

          const result = await upsertProviderAvailability({
            id: provideIdAv,

            data: {
              availabilities: Object.keys(groupDates).map((key) => {
                return {
                  indexDate: key,
                  availability: groupDates[key],
                };
              }),
              force: force,
              datesToDelete,
              marketId
            },
          }).unwrap();
          getWeeklyDateRanges();
          if (result?.data?.alert) {

            // showAlert(result?.data?.alert, "warning");
            setIsConfModalOpen({
              status: true,
              message: result?.data?.alert
            })
            return;
          }
          else {
            setIsDelete(false);
            setIsConfModalOpen({
              status: false,
              message: null
            })
          }
        }

      } else {
        if (overlappingWeeksWithDates?.length) {
          // const existingDates = apiData;
          const [start, end] = eventTitle?.split("-") || [];
          const selectedDates = overlappingWeeksWithDates?.map(
            (date) => date?.date
          );
          const eventExists = apiData.some((a) => {
            // Check if any selected date overlaps existing availability dates
            const dateOverlap = a.dates.some((d) => selectedDates.includes(d));
            if (!dateOverlap) return false;

            // Parse times for comparison
            const existingStart = moment(a.working_hours.start_time, "HH:mm");
            const existingEnd = moment(a.working_hours.end_time, "HH:mm");
            const newStart = moment(selectedStartTime, "HH:mm");
            const newEnd = moment(selectedEndTime, "HH:mm");

            // Return true if new slot overlaps (fully or partially)
            // Overlap means newStart < existingEnd && newEnd > existingStart
            return newStart.isBefore(existingEnd) && newEnd.isAfter(existingStart);
          });


          // if (eventExists) {
          //   showAlert("Some of the selected dates and time slots overlap with existing custom availability. Please check and try again.");
          //   return;
          // }

          // Match by date, time slot, and template_id so we only update the current event's block
          // (avoids duplicate when editing template events)
          // Without a time slot there is no event being edited, so nothing may be updated in place
          const matchesEditedBlock = (a) =>
            Boolean(start && end) &&
            a.dates.length === 1 &&
            selectedDates?.length === 1 &&
            a.dates[0] === selectedDates?.[0] &&
            templateIdMatch(a) &&
            normalizeTimeToHHmm(a.working_hours?.start_time) === normalizeTimeToHHmm(start) &&
            normalizeTimeToHHmm(a.working_hours?.end_time) === normalizeTimeToHHmm(end);

          const singleDay = apiData.find(matchesEditedBlock);
          let availabilityData = [];
          if (singleDay) {
            availabilityData = apiData.map((api) => {
              if (matchesEditedBlock(api)) {
                return {
                  ...api,
                  working_hours: {
                    start_time: selectedStartTime,
                    end_time: selectedEndTime,
                  },
                  appointment_type_ids: selectedAppointmentTypes || [],
                  zone_ids: selectedZones || [],
                  zip_codes: selectedZipCodes || [],
                };
              }
              return api;
            });
          } else {
            const newDates = apiData
              ?.map((item) => {
                if (
                  item?.dates?.length === 1 &&
                  selectedDates?.length === 1 &&
                  item?.dates[0] === selectedDates?.[0] &&
                  templateIdMatch(item) &&
                  normalizeTimeToHHmm(item?.working_hours?.start_time) === normalizeTimeToHHmm(start) &&
                  normalizeTimeToHHmm(item?.working_hours?.end_time) === normalizeTimeToHHmm(end)
                )
                  return undefined;

                let isSame = false;
                if (selectedDates?.length == 1) {
                  const isSameAppointmentTypes = areEqualArrays(
                    item?.appointment_type_ids,
                    selectedAppointmentTypes
                  );
                  const isSameZones = areEqualArrays(
                    item?.zone_ids,
                    selectedZones
                  );
                  const isSameZipCodes = areEqualArrays(
                    item?.zip_codes,
                    selectedZipCodes
                  );
                  const isSameWorkingHours =
                    normalizeTimeToHHmm(item?.working_hours?.start_time) === normalizeTimeToHHmm(selectedStartTime) &&
                    normalizeTimeToHHmm(item?.working_hours?.end_time) === normalizeTimeToHHmm(selectedEndTime);
                  isSame =
                    isSameAppointmentTypes &&
                    isSameZones &&
                    isSameZipCodes &&
                    isSameWorkingHours;
                }

                // Only remove a date from this item if it matches the time slot and template we're editing
                // (so other templates/time slots for the same date are preserved)
                const itemMatchesCurrentSlot =
                  start && end &&
                  templateIdMatch(item) &&
                  normalizeTimeToHHmm(item?.working_hours?.start_time) === normalizeTimeToHHmm(start) &&
                  normalizeTimeToHHmm(item?.working_hours?.end_time) === normalizeTimeToHHmm(end);
                const dates = item?.dates.filter(
                  (date) =>
                    isSame ||
                    !selectedDates?.includes(date) ||
                    !itemMatchesCurrentSlot
                );

                if (dates?.length === 0) {
                  return undefined;
                }

                return {
                  ...item,
                  dates,
                  date_range: {
                    start_date: dates[0],
                    end_date: dates[dates.length - 1],
                  },
                };
              })
              .filter(Boolean);
            const consecutiveDates = splitAllConsecutiveDateGroups(newDates);

            availabilityData = [...consecutiveDates];

            const isSameEventExists = consecutiveDates?.find((availability) => {
              if (!templateIdMatch(availability)) return false;
              const isSameAppointmentTypes = areEqualArrays(
                availability?.appointment_type_ids,
                selectedAppointmentTypes
              );
              const isSameZones = areEqualArrays(
                availability?.zone_ids,
                selectedZones
              );
              const isSameZipCodes = areEqualArrays(
                availability?.zip_codes,
                selectedZipCodes
              );
              const isSameWorkingHours =
                normalizeTimeToHHmm(availability?.working_hours?.start_time) === normalizeTimeToHHmm(selectedStartTime) &&
                normalizeTimeToHHmm(availability?.working_hours?.end_time) === normalizeTimeToHHmm(selectedEndTime);
              return (
                availability?.dates?.includes(selectedDates?.[0]) &&
                isSameAppointmentTypes &&
                isSameZones &&
                isSameZipCodes &&
                isSameWorkingHours
              );
            });

            if (!isSameEventExists) {
              const newBlock = {
                date_range: {
                  start_date: moment(selectedRange.start).format("YYYY-MM-DD"),
                  end_date: moment(selectedRange.end).format("YYYY-MM-DD"),
                },
                dates: overlappingWeeksWithDates?.map((e) => e.date),
                working_days: applyToDays
                  .filter(({ id }) => selectedApplyToDays.includes(id))
                  .map(({ name }) => name),
                working_hours: {
                  start_time: selectedStartTime,
                  end_time: selectedEndTime,
                },
                appointment_type_ids: selectedAppointmentTypes || [],
                zone_ids: selectedZones || [],
                zip_codes: selectedZipCodes || [],
                isWeeklyEv: false,
              };
              if (selectedEvent?.template_id != null) {
                newBlock.template_id = selectedEvent.template_id;
              }
              availabilityData?.push(newBlock);
            }
          }


          const availabilities = [
            {
              indexDate: moment(selectedRange.start)
                .startOf("month")
                .format("YYYY-MM-DD"),
              availability: availabilityData,
            },
          ];

          await upsertProviderAvailability({
            id: provideIdAv,
            data: {
              availabilities,
              force: true,
              marketId
            },
          }).unwrap();
        }
      }
    }
    // Fetch updated availability after all updates are done
    await getProviderAvailabilityFun();
    setIsMultiDayAvailabilityModalOpen(false);
    setIsEdited(false);
    setDaysSelected(applyToDays.map(({ id }) => id));
    closeModal({ isClearAll: false });
  };
  const getDatesBetween = (start, end) => {
    const dates = [];
    let current = moment(start).startOf("day");

    const last = moment(end).startOf("day");

    while (current <= last) {
      dates.push(current.format("YYYY-MM-DD"));
      current = current.add(1, "day");
    }
    return dates;
  };
  // const deleteWeeklyEvent = async () => {
  //   // Use moment with timezone handling
  //   const startDate = moment(selectedRange.start);
  //   const endDate = moment(selectedRange.end);

  //   const dates = [];
  //   let current = startDate.clone();

  //   console.log(startDate, endDate, ">> Start and end date");
  //   // Generate dates in the provider's timezone
  //   while (current.isSameOrBefore(endDate, 'day')) {
  //     // Format date in provider's timezone perspective
  //     const dateInProviderTimezone = current.clone().tz(providerTimezone || moment.tz.guess());
  //     dates.push(dateInProviderTimezone.format('YYYY-MM-DD'));
  //     current.add(1, 'day');
  //   }

  //   const dayMap = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

  //   setDayPreferences((prev) => {
  //     let updated = { ...(prev || {}) };

  //     dates.forEach((dateStr) => {
  //       // Parse the date in provider's timezone
  //       const dateInProviderTz = moment.tz(dateStr, 'YYYY-MM-DD', providerTimezone || moment.tz.guess());

  //       // Get the day of week in provider's timezone
  //       const dayName = dayMap[dateInProviderTz.day()];

  //       // ⭐ If day not present, initialize it
  //       if (!updated[dayName]) {
  //         updated[dayName] = {
  //           visits_count: 0,
  //           working_hours: {
  //             start: updated["ALL"]?.working_hours?.start,
  //             end: updated["ALL"]?.working_hours?.end
  //           },
  //           appointment_type_ids: [],
  //           zone_ids: [],
  //           zip_codes: [],
  //           deleted_dates: [],
  //         };
  //       }

  //       // ⭐ Add deleted date
  //       updated[dayName] = {
  //         ...updated[dayName],
  //         deleted_dates: Array.from(
  //           new Set([...(updated[dayName]?.deleted_dates || []), dateStr])
  //         ),
  //       };
  //     });
  //     return updated;
  //   });

  //   setUpdateWeeklySettings(true);
  //   setSelectedEvent(null);
  //   closeModal({ isClearAll: false });
  // };

  const deleteWeeklyEvent = async (force) => {
    // Use UTC dates to avoid timezone confusion
    const startDate = moment.utc(selectedRange.start);
    const endDate = moment.utc(selectedRange.end);


    const dates = [];
    let current = startDate.clone();

    // Generate dates in UTC
    while (current.isSameOrBefore(endDate, 'day')) {
      const dateStr = current.format('YYYY-MM-DD');
      dates.push(dateStr);
      current.add(1, 'day');
    }

    const dayMap = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
    const result = await validateDeletedDates({
      providerId: provideIdAv,
      deletedDates: dates,
      force: true,
      marketId
    })?.unwrap();
    if (result?.data?.conflictFound && !force) {
      setIsConfModalOpen({ status: true, message: result?.data?.alertMessage, isDelete: true })
      return;
    }
    setIsConfModalOpen({ status: false, message: null })
    setDayPreferences((prev) => {
      let updated = { ...(prev || {}) };


      dates.forEach((dateStr) => {
        // Parse date as UTC
        const dateUtc = moment.utc(dateStr, 'YYYY-MM-DD');
        // Get day of week from UTC (0=Sunday, 6=Saturday)
        const dayIndex = dateUtc.day();
        const dayName = dayMap[dayIndex];


        // Initialize day if not present
        if (!updated[dayName]) {
          updated[dayName] = {
            visits_count: 0,
            working_hours: {
              start: updated["ALL"]?.working_hours?.start || "09:00",
              end: updated["ALL"]?.working_hours?.end || "17:00"
            },
            appointment_type_ids: [...(updated["ALL"]?.appointment_type_ids || [])],
            zone_ids: [...(updated["ALL"]?.zone_ids || [])],
            zip_codes: [...(updated["ALL"]?.zip_codes || [])],
            deleted_dates: [],
          };
        }

        // Add to deleted_dates if not already present
        const currentDeletedDates = updated[dayName]?.deleted_dates || [];
        if (!currentDeletedDates.includes(dateStr)) {
          updated[dayName] = {
            ...updated[dayName],
            deleted_dates: [...currentDeletedDates, dateStr],
          };
        }
      });
      return updated;
    });

    setUpdateWeeklySettings(true);
    setSelectedEvent(null);
    closeModal({ isClearAll: false });
  };
  const dayPropGetter = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date < today) {
      return {
        style: {
          backgroundColor: "#F5F5F5",
          color: "#A1A1A1",
          pointerEvents: "none",
          cursor: "not-allowed",
        },
      };
    }
    if (selectedRange) {
      const { start, end } = selectedRange;
      const isInRange = date >= start && date <= end;
      const isSingleDay = moment(start).isSame(end, "day");
      if (isInRange) {
        if (!isSingleDay) {
          return {
            style: {
              borderLeft:
                date.getTime() === start.getTime() ? "2px solid #c0e1f9" : "",
              borderRight:
                date.getTime() === end.getTime() ? "2px solid #c0e1f9" : "",
              borderTop: "2px solid #c0e1f9",
              borderBottom: "2px solid #c0e1f9",
            },
          };
        } else {
          return {
            style: {
              border: "2px solid #c0e1f9",
            },
          };
        }
      }
    }
    return {};
  };
  const handleIconClick = (obj) => {
    if (obj?.start == true) {
      setCalendarOpenStart(!calendarOpenStart);
      setTimePickerOpenStart(false);
    } else {
      setCalendarOpenEnd(!calendarOpenEnd);
      setTimePickerOpenEnd(false);
    }
  };
  const handleTimeIconClick = (obj) => {
    if (obj?.start == true) {
      setTimePickerOpenStart(!timePickerOpenStart);
      setCalendarOpenStart(false);
    } else {
      setTimePickerOpenEnd(!timePickerOpenEnd);
      setCalendarOpenEnd(false);
    }
  };
  const groupEventsByTitle = (events) => {
    return events.reduce((acc, event) => {
      if (!acc[event.title]) {
        acc[event.title] = [];
      }
      acc[event.title].push(event);
      return acc;
    }, {});
  };

  // Grouping the events
  const groupedEvents = groupEventsByTitle(eventDetails);
  const handleClickOutside = (event) => {
    if (
      calendarRefStart.current &&
      !calendarRefStart.current.contains(event.target)
    ) {
      setCalendarOpenStart(false);
    }
    if (
      timePickerRefStart.current &&
      !timePickerRefStart.current.contains(event.target)
    ) {
      setTimePickerOpenStart(false);
    }
    if (
      calendarRefEnd.current &&
      !calendarRefEnd.current.contains(event.target)
    ) {
      setCalendarOpenEnd(false);
    }
    if (
      timePickerRefEnd.current &&
      !timePickerRefEnd?.current.contains(event.target)
    ) {
      setTimePickerOpenEnd(false);
    }
  };
  const handleEventClick = (event) => {
    setSelectedEvent(event);
    if (marketId === 'ALL') {
      return;
    }
    if (event.isLeave) {
      setIsLeaveModalOpen(true);
    } else {
      // Check permission before allowing edit
      if (!user?.permissions?.includes('provider_settings.edit_calendar_view_settings')) {
        return;
      }
      setEventAvailabilityType("singleDay");
      setIsEventModalOpen(true);


      setSelectedRange({
        start: event?.start,
        end: event?.end,
      });


    }
  };
  const closeEventModal = () => {
    setIsEventModalOpen(false);
    setSelectedEvent(null);
  };

  const getProviderTimezoneTime = (date, time, timezone) => {
    if (date && time && timezone) {
      const estDateTime = moment.tz(`${date}T${time}`, estTimezone);
      return estDateTime.clone().tz(timezone).format("HH:mm");
    } else {
      return time;
    }
  };

  const getEstTimezoneTime = (date, time, timezone) => {
    if (date && time && timezone) {
      const providerDateTime = moment.tz(`${date}T${time}`, timezone);
      return providerDateTime.clone().tz(estTimezone).format("HH:mm");
    } else {
      return time;
    }
  };

  // Map timezone abbreviations to IANA timezone identifiers
  const getIANATimezone = (timezone) => {
    if (!timezone) return null;
    
    // If it's already an IANA timezone (contains '/'), return as-is
    if (timezone.includes('/')) {
      return timezone;
    }
    
    return US_TIMEZONE_MAP[timezone.toUpperCase()] || timezone;
  };

  // Convert time from one timezone to another
  const convertTimezone = (date, time, fromTimezone, toTimezone) => {
    if (date && time && fromTimezone && toTimezone) {
      const fromIANA = getIANATimezone(fromTimezone);
      const toIANA = getIANATimezone(toTimezone);
      
      if (fromIANA && toIANA) {
        const sourceDateTime = moment.tz(`${date}T${time}`, fromIANA);
        return sourceDateTime.clone().tz(toIANA).format("HH:mm");
      }
    }
    return time;
  };

  const findMarketById = (id) => {
    if (id == null || !markets?.length) return null;
    return markets.find((m) => m.id === id || String(m.id) === String(id)) || null;
  };

  // Get primary market timezone (used by the combined All Markets view)
  const getPrimaryMarketTimezone = () => {
    if (!markets || markets.length === 0) return null;
    const primaryMarket = markets.find(m => m.is_primary_market === true);
    return primaryMarket?.timezone || null;
  };

  // Individual market tabs display that market's local timezone.
  // The combined view stays on the primary market timezone.
  const getDisplayTimezone = () => {
    if (marketId && marketId !== "ALL") {
      const selectedTimezone = findMarketById(marketId)?.timezone ?? 'EST';
      if (selectedTimezone) return selectedTimezone;
    }
    return getPrimaryMarketTimezone();
  }; 

  const doAvailabilityEventsOverlap = (eventA, eventB) => {
    const startA = moment(eventA.start);
    const endA = moment(eventA.end);
    const startB = moment(eventB.start);
    const endB = moment(eventB.end);
    return endA.isAfter(startB) && startA.isBefore(endB);
  };

  // Transform weekly settings into calendar events
  const transformedWeeklySettings = React.useMemo(() => {
    try {
      // When marketId is 'ALL', we use markets array, so don't return early
      // Only return early if marketId is not 'ALL' and dayPreferences is missing
      if (marketId !== 'ALL' && !dayPreferences) return [];
      // Also return early if marketId is 'ALL' but markets array is empty
      if (marketId === 'ALL' && (!markets || markets.length === 0)) return [];

      const weeklyEvents = [];
      // const deletedDates = []
      const currentMonth = moment(currentDate).startOf("month");
      const endOfMonth = moment(currentDate).endOf("month");

      // Helper function to get day number (0-6) from day name
      const getDayNumber = (dayName) => {
        const dayMap = {
          SUNDAY: 0,
          MONDAY: 1,
          TUESDAY: 2,
          WEDNESDAY: 3,
          THURSDAY: 4,
          FRIDAY: 5,
          SATURDAY: 6,
        };
        return dayMap[dayName];
      };

      // Process each day's preferences
      if (marketId == 'ALL') {

        markets?.forEach(market => {
          const workingDays = market?.constraints?.working_days;
          const dayPreferences = market?.constraints?.day_preferences;
          if (workingDays && workingDays?.length) {
            workingDays?.forEach((day) => {
              if (day === "ALL") return; // Skip the ALL settings as they're defaults
              const preferences = dayPreferences?.[day] || dayPreferences?.["ALL"];
              if (preferences) {
                const { working_hours } = preferences || {};
                if (!working_hours?.start || !working_hours?.end) return;

                // Get all dates of this day in the current month
                let date = moment(currentMonth);

                while (date.isSameOrBefore(endOfMonth)) {
                  if (date.day() === getDayNumber(day)) {
                    const dateStr = date.format("YYYY-MM-DD");
                    // Convert from market's timezone to primary market's timezone
                    const primaryMarketTimezone = getPrimaryMarketTimezone();
                    const start_time = (market?.timezone && primaryMarketTimezone)
                      ? convertTimezone(dateStr, working_hours.start, market.timezone, primaryMarketTimezone)
                      : getProviderTimezoneTime(
                          dateStr,
                          working_hours.start,
                          providerTimezone
                        );
                    const end_time = (market?.timezone && primaryMarketTimezone)
                      ? convertTimezone(dateStr, working_hours.end, market.timezone, primaryMarketTimezone)
                      : getProviderTimezoneTime(
                          dateStr,
                          working_hours.end,
                          providerTimezone
                        );
                    const startDateTime = `${dateStr}T${start_time}`;
                    const endDateTime = `${dateStr}T${end_time}`;

                    const formattedStart = moment(startDateTime).format("hh:mm A");
                    const formattedEnd = moment(endDateTime).format("hh:mm A");

                    if (
                      !dayPreferences[date.format("dddd").toUpperCase()]?.deleted_dates?.includes(
                        date.format("YYYY-MM-DD")
                      )
                    ) {
                      weeklyEvents.push({
                        start: new Date(startDateTime),
                        end: new Date(endDateTime),
                        title: `${formattedStart} to ${formattedEnd}`,
                        time_slots: [`${start_time}-${end_time}`],
                        appointment_type_ids: preferences.appointment_type_ids,
                        zone_ids: preferences.zone_ids,
                        zip_codes: preferences.zip_codes,
                        dates: [date.format("YYYY-MM-DD")],
                        isWeeklyEv: true,
                        day: day,
                        marketId: market?.id,
                        marketCode: market?.market_name,
                        marketName: market?.provider_group_name,
                        isPrimaryMarket: market?.is_primary_market,
                      });
                    }
                  }
                  date = date.add(1, "day");
                  // continue;
                }
              }
            });
          }
        });

      } else {
        const selectedMarketData = findMarketById(marketId);
        const marketWorkingDays = selectedMarketData?.constraints?.working_days || workingDays;
        const marketDayPreferences = selectedMarketData?.constraints?.day_preferences || dayPreferences;
        if (marketWorkingDays && marketWorkingDays?.length) {
          marketWorkingDays?.forEach((day) => {
            if (day === "ALL") return; // Skip the ALL settings as they're defaults
            const preferences = marketDayPreferences?.[day] || marketDayPreferences?.["ALL"];
            if (preferences) {
              const { working_hours } = preferences || {};
              if (!working_hours?.start || !working_hours?.end) return;

              // Get all dates of this day in the current month
              let date = moment(currentMonth);

              while (date.isSameOrBefore(endOfMonth)) {
                if (date.day() === getDayNumber(day)) {
                  const dateStr = date.format("YYYY-MM-DD");
                  // Individual tab: show this market's local timezone, not the primary market.
                  const displayTimezone = getDisplayTimezone();
                  const marketTimezone = findMarketById(marketId)?.timezone;
                  const start_time = (marketTimezone && displayTimezone)
                    ? convertTimezone(dateStr, working_hours.start, marketTimezone, displayTimezone)
                    : getProviderTimezoneTime(
                        dateStr,
                        working_hours.start,
                        providerTimezone
                      );
                  const end_time = (marketTimezone && displayTimezone)
                    ? convertTimezone(dateStr, working_hours.end, marketTimezone, displayTimezone)
                    : getProviderTimezoneTime(
                        dateStr,
                        working_hours.end,
                        providerTimezone
                      );
                  const startDateTime = `${dateStr}T${start_time}`;
                  const endDateTime = `${dateStr}T${end_time}`;

                  const formattedStart = moment(startDateTime).format("hh:mm A");
                  const formattedEnd = moment(endDateTime).format("hh:mm A");

                  if (
                    !marketDayPreferences[date.format("dddd").toUpperCase()]?.deleted_dates?.includes(
                      date.format("YYYY-MM-DD")
                    )
                  ) {
                    weeklyEvents.push({
                      start: new Date(startDateTime),
                      end: new Date(endDateTime),
                      title: `${formattedStart} to ${formattedEnd}`,
                      time_slots: [`${start_time}-${end_time}`],
                      appointment_type_ids: preferences.appointment_type_ids,
                      zone_ids: preferences.zone_ids,
                      zip_codes: preferences.zip_codes,
                      dates: [date.format("YYYY-MM-DD")],
                      isWeeklyEv: true,
                      day: day,
                      marketId: marketId,
                      marketCode: findMarketById(marketId)?.market_name,
                      marketName: findMarketById(marketId)?.provider_group_name,
                      isPrimaryMarket: findMarketById(marketId)?.is_primary_market,
                    });
                  }
                }
                date = date.add(1, "day");
                // continue;
              }
            }
          });
        }
      }


      // // Filter out weekly events that fall on dates covered by full-day leaves
      // const fullDayLeaveDates = new Set(
      //   (leaves || []).flatMap((leave) => {
      //     const start = moment(leave.startDate, "YYYY-MM-DD");
      //     const end = moment(leave.endDate, "YYYY-MM-DD");

      //     const dates = [];
      //     let current = start.clone();

      //     while (current.isSameOrBefore(end, "day")) {
      //       const currentDate = current.format("YYYY-MM-DD");

      //       const isStartDate = current.isSame(start, "day");
      //       const isEndDate = current.isSame(end, "day");

      //       const excludeStart = isStartDate && leave.startTime;
      //       const excludeEnd = isEndDate && leave.endTime;

      //       // Push only if it's not excluded
      //       if (!(excludeStart || excludeEnd)) {
      //         dates.push(currentDate);
      //       }

      //       current.add(1, "day");
      //     }

      //     return dates;
      //   })
      // );      

      // const filteredWeeklyEvents = weeklyEvents.filter(event => {
      //   return !event.dates.some(date => fullDayLeaveDates.has(date));
      // });
      // Keep all weekly events here; mergedEvents hides overlapping global slots when custom exists.
      return weeklyEvents;
    } catch (error) {
      console.error(error);
      return [];
    }
  }, [dayPreferences, currentDate, leaves, markets, marketId, providerTimezone, workingDays]);

  // Transform leaves into calendar events
  const transformedLeaves =
    leaves?.map((leave) => {
      const startDate = moment(leave.startDate, "YYYY-MM-DD").startOf("day").toDate();
      const endDate = moment(leave.endDate, "YYYY-MM-DD").endOf("day").toDate();
      // const startTime = getProviderTimezoneTime(leave?.startDate, leave?.startTime, providerTimezone);
      // const endTime = getProviderTimezoneTime(leave?.endDate, leave?.endTime, providerTimezone);
      const startTime = leave?.startTime;
      const endTime = leave?.endTime;

      return {
        start: startDate,
        end: endDate,
        startTime: startTime,
        endTime: endTime,
        // title: `Absence: ${capitalizeFirstWords(LEAVE_TYPE[leave.type].replaceAll("_", " "))
        title: `Absence: ${capitalizeFirstWords(leave?.details ? leave?.details?.replaceAll("_", " ") : '')
          }${leave.startTime && leave.endTime
            ? ` (${moment(startTime, "HH:mm").format("hh:mm A")} - ${moment(endTime, "HH:mm").format("hh:mm A")})`
            : ""
          }`,
        isLeave: true,
        leaveType: leave.type,
      }
    }) || [];

  // --- Custom event merging logic for TimeOff (leave) and availability events ---
  const mergedEvents = React.useMemo(() => {
    // Helper to get date string (YYYY-MM-DD)
    const getDateStr = (date) => moment(date).format("YYYY-MM-DD");

    // 1. Index all leaves by date
    const leaveMap = {};
    (leaves || []).forEach((leave) => {
      const start = moment(leave.startDate, "YYYY-MM-DD");
      const end = moment(leave.endDate, "YYYY-MM-DD");
      let current = start.clone();
      while (current.isSameOrBefore(end, "day")) {
        const dateStr = current.format("YYYY-MM-DD");
        if (!leaveMap[dateStr]) leaveMap[dateStr] = [];
        leaveMap[dateStr].push(leave);
        current.add(1, "day");
      }
    });

    // 2. Gather all events (providerAv + weekly)
    const allAvailEvents = [
      ...(providerAv || []),
      ...(transformedWeeklySettings || []),
    ];
    // 3. Group availabilities by date
    const availByDate = {};
    allAvailEvents.forEach((ev) => {
      // Some events span multiple days, split by day
      const start = moment(ev.start);
      const end = moment(ev.end);
      let current = start.clone();
      while (current.isSameOrBefore(end, "day")) {
        const dateStr = current.format("YYYY-MM-DD");
        if (!availByDate[dateStr]) availByDate[dateStr] = [];
        availByDate[dateStr].push(ev);
        current.add(1, "day");
      }
    });

    // 4. Build merged events
    let merged = [];
    const processedDates = new Set();
    // For each date in the month (or with events)
    Object.keys({ ...availByDate, ...leaveMap }).forEach((dateStr) => {
      processedDates.add(dateStr);
      const leavesForDay = leaveMap[dateStr] || [];
      let availsForDay = availByDate[dateStr] || [];
      // Separate monthly and weekly events
      const monthlyEvents = availsForDay.filter(ev => ev.isMonthlyEv);
      const weeklyEvents = availsForDay.filter(ev => ev.isWeeklyEv);

      let finalAvailsForDay = [];

if (monthlyEvents.length && weeklyEvents.length) {
  const result = [];

  // Group by market
  const markets = new Set([
    ...monthlyEvents.map(ev => ev.marketId),
    ...weeklyEvents.map(ev => ev.marketId)
  ]);

  markets.forEach(marketId => {
    const monthlyForMarket = monthlyEvents.filter(ev => ev.marketId === marketId);
    const weeklyForMarket = weeklyEvents.filter(ev => ev.marketId === marketId);

    if (monthlyForMarket.length && weeklyForMarket.length) {
      result.push(
        ...monthlyForMarket,
        ...weeklyForMarket.filter(
          (weeklyEv) =>
            !monthlyForMarket.some((monthlyEv) =>
              doAvailabilityEventsOverlap(weeklyEv, monthlyEv)
            )
        )
      );
    } else {
      // If only one type exists for this market, keep all
      result.push(...monthlyForMarket, ...weeklyForMarket);
    }
  });

  finalAvailsForDay = result;
} else {
  finalAvailsForDay = availsForDay;
}



      availsForDay = finalAvailsForDay;
      // // If any isMonthlyEv event exists for this day, filter out others
      // const hasMonthly = availsForDay.some(ev => ev.isMonthlyEv);
      // if (hasMonthly) {
      //   availsForDay = availsForDay.filter(ev => ev.isMonthlyEv);
      // }
      // Check for full-day leave (no start/end time)
      const fullDayLeave = leavesForDay.find((l) => !l.startTime && !l.endTime);
      if (fullDayLeave) {
        // Only show the leave event for this day
        const leaveEv = transformedLeaves.find(
          (ev) => getDateStr(ev.start) === dateStr && ev.isLeave
        );
        if (leaveEv) merged.push(leaveEv);
        return;
      }
      // Handle partial-day leaves
      let handledAvail = new Set();
      leavesForDay.forEach((leave) => {
        if (leave.startTime && leave.endTime) {
          availsForDay.forEach((avail, idx) => {
            if (handledAvail.has(idx) || !avail.time_slots) return;
            const [availStartTime, availEndTime] = avail.time_slots[0].split('-');
            const availStart = moment(dateStr + 'T' + availStartTime);
            const availEnd = moment(dateStr + 'T' + availEndTime);
            const leaveStart = moment(dateStr + 'T' + leave.startTime);
            const leaveEnd = moment(dateStr + 'T' + leave.endTime);
            // Only process if there is any overlap at all
            if (availEnd.isAfter(leaveStart) && availStart.isBefore(leaveEnd)) {
              // If leave starts after availability start, create partial before leave
              if (leaveStart.isAfter(availStart)) {
                const formattedStart = moment(availStart).format("hh:mm A");
                const formattedEnd = moment(leaveStart).format("hh:mm A");
                merged.push({
                  ...avail,
                  start: availStart.toDate(),
                  end: leaveStart.toDate(),
                  type: 'partial',
                  title: `${formattedStart} to ${formattedEnd}`,
                });
              }
              // Add leave event (from transformedLeaves)
              const leaveEv = transformedLeaves.find(
                (ev) => getDateStr(ev.start) === dateStr && ev.isLeave &&
                  ev.startTime === leave.startTime && ev.endTime === leave.endTime
              );
              if (leaveEv) merged.push(leaveEv);
              // If leave ends before availability end, create partial after leave
              if (leaveEnd.isBefore(availEnd)) {
                const formattedStart = moment(leaveEnd).format("hh:mm A");
                const formattedEnd = moment(availEnd).format("hh:mm A");
                merged.push({
                  ...avail,
                  start: leaveEnd.toDate(),
                  end: availEnd.toDate(),
                  type: 'partial',
                  title: `${formattedStart} to ${formattedEnd}`,
                });
              }
              handledAvail.add(idx);
            }
          });
        }
      });
      // Add any availabilities not overlapped by partial leave
      availsForDay.forEach((avail, idx) => {
        if (!handledAvail.has(idx)) merged.push(avail);
      });
      // Add any partial-day leave events not already added
      leavesForDay.forEach((leave) => {
        if (leave.startTime && leave.endTime) {
          const leaveEv = transformedLeaves.find(
            (ev) => getDateStr(ev.start) === dateStr && ev.isLeave &&
              ev.startTime === leave.startTime && ev.endTime === leave.endTime
          );
          if (leaveEv && !merged.some(ev =>
            ev.isLeave &&
            moment(ev.start).isSame(moment(leaveEv.start)) &&
            moment(ev.end).isSame(moment(leaveEv.end)) &&
            ev.startTime === leaveEv.startTime &&
            ev.endTime === leaveEv.endTime
          )) merged.push(leaveEv);
        }
      });
    });
    // Add any leave events not already included (for days with no availabilities)
    transformedLeaves.forEach((ev) => {
      const dateStr = getDateStr(ev.start);
      if (!processedDates.has(dateStr)) merged.push(ev);
    });
    // Filter out duplicate events
    // const uniqueMerged = merged.filter((event, idx, arr) =>
    //   idx === arr.findIndex(ev =>
    //     moment(ev.start).isSame(moment(event.start)) &&
    //     moment(ev.end).isSame(moment(event.end)) &&
    //     (ev.startTime || '') === (event.startTime || '') &&
    //     (ev.endTime || '') === (event.endTime || '') &&
    //     (ev.title || '') === (event.title || '')
    //   )
    // );
    return merged;
  }, [providerAv, transformedWeeklySettings, transformedLeaves, leaves]);

  // Update eventPropGetter to color partial events orange
  const eventPropGetter = (event) => {
    const isPast = new Date(event.end) < new Date() || marketId == "ALL";

    // 🎯 Base style depending on event type
    let baseStyle = {};

    if (event.isLeave) {
      baseStyle = {
        backgroundColor: "#fca5a5",
        padding: "4px 5px",
        borderRadius: "2px",
        color: "#991b1b",
      };
    } else if (event.type === "partial") {
      baseStyle = {
        backgroundColor: "#fff4c7",
        padding: "4px 5px",
        borderRadius: "2px",
        color: "#d8821c",
      };
    } else {
      // Check if this is a secondary market (isPrimaryMarket is false)
      const isSecondaryMarket = event.isPrimaryMarket === false;
      
      if (isSecondaryMarket) {
        // Secondary Market - Orange color
        baseStyle = {
          backgroundColor: "#fed7aa",
          padding: "4px 5px",
          borderRadius: "2px",
          color: "#9a3412",
        };
      } else {
        // Primary Market - Blue color (default)
        baseStyle = {
          backgroundColor: "#dbeafe",
          padding: "4px 5px",
          borderRadius: "2px",
          color: "#1e40af",
        };
      }
    }

    // Build tooltip text for market information (only for availability events with market info)
    let tooltipTitle = "";
    if (event.marketName && !event.isLeave) {
      tooltipTitle = event.marketCode 
        ? `${event.marketName} (${event.marketCode})`
        : event.marketName;
    }

    // 🎯 For past events or when marketId is "ALL" → keep colors, reduce opacity, allow hover but disable click
    if (isPast) {
      return {
        style: {
          ...baseStyle,         // keep original colors
          opacity: marketId == "ALL" ? 0.7 : 0.5,
          cursor: marketId == "ALL" ? "default" : "not-allowed",
          // Allow pointer events for hovering when marketId is "ALL", but prevent click
          pointerEvents: marketId == "ALL" ? "auto" : "none",
        },
      };
    }

    // Normal event
    return {
      style: baseStyle,
    };
  };

  // Custom event component with tooltip showing market information
  const EventComponent = ({ event }) => {
    // Build tooltip text for market information (only for availability events with market info)
    const tooltipText = event.marketName && !event.isLeave && event.marketCode 
      ? `${event.marketName} (${event.marketCode})`
      : event.marketName && !event.isLeave
      ? event.marketName
      : null;

    // Use native title attribute for tooltip to avoid conflicts
    return (
      <div 
        title={tooltipText || undefined}
        style={{ width: "100%", height: "100%" }}
      >
        {event.title}
      </div>
    );
  };

  // Label follows the selected market tab. All Markets stays on the primary timezone.
  const getDisplayTimezoneText = () => {
    const timezone = getDisplayTimezone();
    if (!timezone) return null;

    const normalized = timezone.toUpperCase();
    const fullName = US_TIMEZONE_LABELS[normalized];
    const abbreviation = IANA_TO_ABBREVIATION[normalized] || timezone;

    if (fullName) {
      return `Displayed in ${abbreviation} (${fullName})`;
    }

    return `Displayed in ${timezone}`;
  };

  const timezoneText = getDisplayTimezoneText();


  // const matchingRange = weeklyDateRanges?.find((range) => {
  //   const rangeStart = moment(range.start_date);
  //   const rangeEnd = moment(range.end_date);

  //   // ensure these are moment objects
  //   const selectedStart = moment(selectedRange?.start);
  //   const selectedEnd = moment(selectedRange?.end);

  //   // check overlap or inclusion
  //   return (
  //     selectedStart?.isSameOrAfter(rangeStart, "day") &&
  //     selectedEnd?.isSameOrBefore(rangeEnd, "day")
  //   );
  // });

  const matchingRange = weeklyDateRanges?.find((rule) => {
    // Each rule can have multiple assigned ranges (active ones only)
    const activeAssignments = rule.assignments?.filter(
      (a) => a.status === "ACTIVE"
    ) || [];

    // Compare selected date range with each active assignment
    return activeAssignments.some((assignment) => {
      const rangeStart = moment(assignment.start_date);
      const rangeEnd = moment(assignment.end_date);

      const selectedStart = moment(selectedRange?.start);
      const selectedEnd = moment(selectedRange?.end);

      // check if the selected range is fully within assignment range
      return (
        selectedStart.isSameOrAfter(rangeStart, "day") &&
        selectedEnd.isSameOrBefore(rangeEnd, "day")
      );
    });
  });

  // For the clicked event: use template_id so each event shows its own template name (fixes multiple events on same date showing same name)
  const templateForEvent =
    selectedEvent?.template_id != null
      ? weeklyDateRanges?.find((rule) => Number(rule.id) === Number(selectedEvent.template_id))
      : null;

  // Availability added straight from the calendar carries no template_id, so a template whose
  // assignment window merely covers the same dates does not own it. Only fall back for events
  // saved before template_id was stored, and only when the weekday fits the template.
  const legacyTemplateForEvent =
    selectedEvent?.template_id == null &&
      matchingRange?.working_days?.includes(
        moment(selectedEvent?.start).format("dddd").toUpperCase()
      )
      ? matchingRange
      : null;

  const displayRange = templateForEvent ?? legacyTemplateForEvent;


  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  React.useEffect(() => {
    if (!searchTerm.trim()) {
      // Clear expanded sections when search is empty
      setExpandedSections(new Set());
      return;
    }

    // Find all sections that contain matches and expand them
    const expandSectionsWithMatches = (data, parentIds = []) => {
      const sectionsToExpand = new Set();

      data.forEach((item) => {
        const itemId = item.zipCode || item.county || item.state;

        // Check if current item matches search
        const matchesSearch =
          (item.zipCode && item.zipCode.includes(searchTerm)) ||
          (item.city && item.city.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (item.county && item.county.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (item.state && item.state.toLowerCase().includes(searchTerm.toLowerCase()));

        if (matchesSearch) {
          // Expand all parent sections
          parentIds.forEach(parentId => sectionsToExpand.add(parentId));
        }

        // Recursively check children
        if (item.counties) {
          const countyMatches = expandSectionsWithMatches(item.counties, [...parentIds, itemId]);
          if (countyMatches.size > 0) {
            sectionsToExpand.add(itemId);
            countyMatches.forEach(id => sectionsToExpand.add(id));
          }
        }

        if (item.cities) {
          const cityMatches = expandSectionsWithMatches(item.cities, [...parentIds, itemId]);
          if (cityMatches.size > 0) {
            sectionsToExpand.add(itemId);
            cityMatches.forEach(id => sectionsToExpand.add(id));
          }
        }
      });

      return sectionsToExpand;
    };

    const sectionsToExpand = expandSectionsWithMatches(coverageData);
    setExpandedSections(sectionsToExpand);
  }, [searchTerm, coverageData]);

  React.useEffect(() => {
    if (marketId) {
      if (marketId === 'ALL') {
        fetchAllMarketsData();
      } else if (marketId) {
        getProviderAvailabilityFun(marketId);
        getZipCodes();
      }
    }
  }, [currentDate, marketId]);

  const getProviderAvailabilityFun = async (market) => {
    try {
      if (!market && !marketId) return;
      const marketToUse = market ? market : marketId;
      // Prevent processing when marketId is 'ALL' - this should be handled by fetchAllMarketsData
      if (marketToUse === 'ALL') return;
      const requestId = ++availabilityRequestId.current;
      setProviderAv([]);
      // setProviderEv([]);
      setApiData([]);
      const result = await getProviderAvailability({
        id: provideIdAv,
        indexDate: moment(currentDate).startOf("month").format("YYYY-MM-DD"),
        market_id: marketToUse,
        // startDate: obj?.startDate,
        // endDate: obj?.endDate,
      }).unwrap();
      // const transformedEvents = result?.data?.map(item =>
      //     item.availableDates?.map(availableDate => ({
      //         start: new Date(`${availableDate?.date}T${availableDate?.time_slots?.start}`), // Combine date and start time
      //         end: new Date(`${availableDate?.date}T${availableDate?.time_slots?.end}`),
      //         title: availableDate?.title !== "" || availableDate?.title !== undefined || availableDate?.title !== null ? availableDate?.title : "Booked"
      //     }))
      // ).flat(); // Flatten the array if there are multiple available dates

      if (requestId !== availabilityRequestId.current) return;

      const availabilities = JSON.parse(
        result?.data?.availability_json || "[]"
      );

      const dayPreferencesData = result?.data?.weekly_availability?.day_preferences;

      // const dayNames = [
      //   "SUNDAY",
      //   "MONDAY",
      //   "TUESDAY",
      //   "WEDNESDAY",
      //   "THURSDAY",
      //   "FRIDAY",
      //   "SATURDAY",
      // ];
      const transformedEvents = availabilities
        ?.filter((i) => !i?.isWeeklyEv)
        ?.flatMap((availability) => {
          const {
            working_days,
            working_hours,
            appointment_type_ids,
            zip_codes,
            zone_ids,
            template_id,
          } = availability || {};
          // Support both formats: start_time/end_time and start/end
          const start_time = working_hours?.start_time || working_hours?.start;
          const end_time = working_hours?.end_time || working_hours?.end;
          
          // Skip if working hours are missing
          if (!start_time || !end_time) {
            return [];
          }
          
          return availability.dates
            ?.filter((date) => {
              const dayName = moment(date).format("dddd").toUpperCase(); // e.g., 'MONDAY'
              return working_days == null
                ? true
                : working_days.includes(dayName);
            })
            ?.map((date) => {
              const padTime = (time) =>
                time
                  ?.split(":")
                  ?.map((x) => (x.length === 1 ? `0${x}` : x))
                  ?.join(":");

              const toDateTime = (date, time) => {
                if (!time) return null;
                return new Date(`${date}T${time}`);
              };

              // Individual tab: keep times in the selected market's timezone.
              const marketToUseTimezone = findMarketById(marketToUse)?.timezone;
              const displayTimezone = getDisplayTimezone();
              
              const startTimeStr = (marketToUseTimezone && displayTimezone)
                ? convertTimezone(date, padTime(start_time), marketToUseTimezone, displayTimezone)
                : providerTimezone
                ? getProviderTimezoneTime(date, padTime(start_time), providerTimezone)
                : padTime(start_time);

              const endTimeStr = (marketToUseTimezone && displayTimezone)
                ? convertTimezone(date, padTime(end_time), marketToUseTimezone, displayTimezone)
                : providerTimezone
                ? getProviderTimezoneTime(date, padTime(end_time), providerTimezone)
                : padTime(end_time);

              const startDateTime = toDateTime(date, startTimeStr);
              const endDateTime = toDateTime(date, endTimeStr);
              
              // Skip if dates are invalid
              if (!startDateTime || !endDateTime || isNaN(startDateTime.getTime()) || isNaN(endDateTime.getTime())) {
                return null;
              }

              // const formattedStart = startDateTime.toLocaleTimeString([], {
              //   hour: "2-digit",
              //   minute: "2-digit",
              // });

              const formattedStart = moment(startDateTime).format("hh:mm A");

              // const formattedEnd = endDateTime.toLocaleTimeString([], {
              //   hour: "2-digit",
              //   minute: "2-digit",
              // });
              const formattedEnd = moment(endDateTime).format("hh:mm A");
              return {
                start: startDateTime,
                end: endDateTime,
                title: `${formattedStart} to ${formattedEnd}`,
                time_slots: [`${start_time}-${end_time}`],
                appointment_type_ids,
                zip_codes,
                zone_ids,
                dates: availability?.dates,
                template_id: template_id ?? undefined,
                isMonthlyEv: true,
                skipGlobalDates: workingDays == null ? false : true,
                marketId: marketToUse,
                marketCode: findMarketById(marketToUse)?.market_name,
                marketName: findMarketById(marketToUse)?.provider_group_name,
                isPrimaryMarket: findMarketById(marketToUse)?.is_primary_market
              };
            })
            ?.filter((event) => event !== null); // Remove null events
        });
      setProviderAv(transformedEvents);
      setApiData(availabilities);
      // setProviderEv(availabilities?.filter(i => i?.isWeeklyEv))
      // setProviderAv(result?.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Helper function to transform availability data to events
  const transformAvailabilityToEvents = (availabilities, timezone, market_id, marketCode, isPrimaryMarket, marketName) => {
    return availabilities
      ?.filter((i) => !i?.isWeeklyEv)
      ?.flatMap((availability) => {
        const {
          working_days,
          working_hours,
          appointment_type_ids,
          zip_codes,
          zone_ids,
          template_id,
        } = availability || {};
        // Support both formats: start_time/end_time and start/end
        const start_time = working_hours?.start_time || working_hours?.start;
        const end_time = working_hours?.end_time || working_hours?.end;
        
        // Skip if working hours are missing
        if (!start_time || !end_time) {
          return [];
        }
        
        return availability.dates
          ?.filter((date) => {
            const dayName = moment(date).format("dddd").toUpperCase(); // e.g., 'MONDAY'
            return working_days == null
              ? true
              : working_days.includes(dayName);
          })
          ?.map((date) => {
            const padTime = (time) =>
              time
                ?.split(":")
                ?.map((x) => (x.length === 1 ? `0${x}` : x))
                ?.join(":");

            const toDateTime = (date, time) => {
              if (!time) return null;
              return new Date(`${date}T${time}`);
            };
            // Combined view: convert each market into the primary market timezone.
            const primaryMarketTimezone = getPrimaryMarketTimezone();
            const startTimeStr = (timezone && primaryMarketTimezone)
              ? convertTimezone(date, padTime(start_time), timezone, primaryMarketTimezone)
              : providerTimezone
              ? getProviderTimezoneTime(date, padTime(start_time), providerTimezone)
              : padTime(start_time);

            const endTimeStr = (timezone && primaryMarketTimezone)
              ? convertTimezone(date, padTime(end_time), timezone, primaryMarketTimezone)
              : providerTimezone
              ? getProviderTimezoneTime(date, padTime(end_time), providerTimezone)
              : padTime(end_time);

            const startDateTime = toDateTime(date, startTimeStr);
            const endDateTime = toDateTime(date, endTimeStr);
            
            // Skip if dates are invalid
            if (!startDateTime || !endDateTime || isNaN(startDateTime.getTime()) || isNaN(endDateTime.getTime())) {
              return null;
            }

            // const formattedStart = startDateTime.toLocaleTimeString([], {
            //   hour: "2-digit",
            //   minute: "2-digit",
            // });

            const formattedStart = moment(startDateTime).format("hh:mm A");

            // const formattedEnd = endDateTime.toLocaleTimeString([], {
            //   hour: "2-digit",
            //   minute: "2-digit",
            // });
            const formattedEnd = moment(endDateTime).format("hh:mm A");
            return {
              start: startDateTime,
              end: endDateTime,
              title: `${formattedStart} to ${formattedEnd}`,
              time_slots: [`${start_time}-${end_time}`],
              appointment_type_ids,
              zip_codes,
              zone_ids,
              dates: availability?.dates,
              template_id: template_id ?? undefined,
              isMonthlyEv: true,
              skipGlobalDates: workingDays == null ? false : true,
              marketId: market_id,
              marketCode: marketCode,
              marketName: marketName,
              isPrimaryMarket: isPrimaryMarket
            };
          })
          ?.filter((event) => event !== null); // Remove null events
      });
  };
  const getSingleMarketAvailability = async (marketId) => {
    try {
      const result = await getProviderAvailability({
        id: provideIdAv,
        indexDate: moment(currentDate).startOf("month").format("YYYY-MM-DD"),
        market_id: marketId, // Specific market
      }).unwrap();

      return JSON.parse(result?.data?.availability_json || "[]");
    } catch (error) {
      console.error(`Error fetching market ${marketId}:`, error);
      return [];
    }
  };
  const fetchAllMarketsData = async () => {
    try {
      // Clear existing data
      setProviderAv([]);
      setApiData([]);

      // Fetch data for ALL markets in parallel
      const marketPromises = markets.map(market =>
        getSingleMarketAvailability(market.id)
      );

      const allMarketResults = await Promise.all(marketPromises);

      // Combine data from all markets
      const combinedEvents = [];
      const combinedApiData = [];

      allMarketResults.forEach((marketData, index) => {
        const market = markets[index];
        const marketCode = market.market_name;
        const marketName = market.provider_group_name;
        // Transform events for this market
        const marketEvents = transformAvailabilityToEvents(
          marketData,
          market.timezone,
          market.id,
          marketCode,
          market.is_primary_market,
          marketName
        );

        combinedEvents.push(...marketEvents);
        combinedApiData.push(...marketData);
      });
      setProviderAv(combinedEvents);
      setApiData(combinedApiData);
      // setAllMarketsData({
      //   FL: allMarketResults[0] || [],
      //   NY: allMarketResults[1] || [],
      //   // ... add other markets
      // });

    } catch (error) {
      console.error('Error fetching all markets:', error);
    }
  };

  React.useEffect(() => {
    if (user) {
      getAppointmentTypes();
      getZones();
      getZipCodes();
    }
  }, [user]);

  React.useEffect(() => {
    if (selectedCoverage === "default") {
      setDefaultGeographicCoverage(true);
    } else {
      setDefaultGeographicCoverage(false);
    }
  }, [selectedCoverage]);

  React.useEffect(() => {
    if (regularDailySettings && providerWeeklyAvailability) {
      const defaultGeneralSettings =
        providerWeeklyAvailability?.dayPreferences?.["ALL"];
      setSelectedAppointmentTypes([
        ...new Set(defaultGeneralSettings?.appointment_type_ids || []),
      ]);
      setSelectedZones([
        ...new Set([
          ...(defaultGeneralSettings?.zone_ids || []),
          ...(providerDefaultZones || []),
        ]),
      ]);
      setSelectedZipCodes(defaultGeneralSettings?.zip_codes || []);
    }
  }, [regularDailySettings]);

  React.useEffect(() => {
    if (updateWeeklySettings) {
      upsertProviderConstraint(false);
      setUpdateWeeklySettings(false);
    }
  }, [updateWeeklySettings]);

  return (
    <>
      {isModal && (
        <button
          onClick={() => setIsCalendarOpen(true)}
          style={{ marginBottom: "10px" }}
        >
          Open Calendar Modal
        </button>
      )}
      {isCalendarOpen && (
        <div style={isModal ? modalOverlayStyle : undefined}>
          <div
            style={isModal ? modalStyle : componentStyle}
            className={`calendar-main ${!isModal && "pb-0"}`}
          >
            {isModal && (
              <div className="py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
                <span className="font-bold text-gray-800 text-md">
                  Provider Availability
                </span>
                <Tooltip title="Close">
                  <button onClick={() => closeModal({ isClearAll: true })}>
                    <CloseIcon />
                  </button>
                </Tooltip>
              </div>
            )}
            {timezoneText && (
              <div style={{ 
                textAlign: "right", 
                padding: "8px 16px 4px 16px",
                color: "#6b7280",
                fontSize: "12px"
              }}>
                {timezoneText}
              </div>
            )}
            <BigCalendar
              localizer={localizer}
              events={mergedEvents}
              startAccessor="start"
              endAccessor="end"
              selectable
              onSelectSlot={handleSelectSlot}
              onSelectEvent={handleEventClick}
              views={["month", "week", "day"]}
              defaultView="month"
              style={{
                height: isModal ? 550 : "calc(100vh - 300px)",
                width: isModal ? 800 : "100%",
                backgroundColor: "#fff",
                fontSize: "12px",
                textAlign: "center",
              }}
              dayPropGetter={dayPropGetter}
              eventPropGetter={eventPropGetter}
              components={{
                event: EventComponent,
              }}
              className="text-gray-600"
              onNavigate={handleNavigate}
            />
          </div>
        </div>
      )}
      {!isMultiDayAvailability &&
        isCalendarOpen &&
        isWithinAllowedRange &&
        (isEdited?.status === true || isTimeSlotSelect) && (
          <div style={modalOverlayStyle}>
            <div style={modalStyle}>
              <div className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
                <span className="font-bold text-gray-800 text-md">
                  Confirm Availability
                </span>
                <Tooltip title="Close">
                  <button onClick={() => closeModal({ isClearAll: false })}>
                    <CloseIcon />
                  </button>
                </Tooltip>
              </div>
              <div
                style={dateInputContainerStyle}
                className="relative gap-2 px-2 mt-3 calendar-availability"
              >
                <span style={inputWrapperStyle}>
                  <label style={labelStyle}>Start Date & Time</label>
                  <input
                    type="text"
                    value={moment(selectedRange?.start).format(
                      "MM/DD/YYYY  h:mm A"
                    )}
                    readOnly
                    className="pl-2 py-2 pr-14 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg w-[100%] focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span style={iconStyle} className="mr-2 w-12">
                    <Tooltip title="Select Date">
                      <CalendarMonthIcon
                        onClick={() =>
                          handleIconClick({ start: true, end: false })
                        }
                        className="mr-1 cursor-pointer"
                      />
                    </Tooltip>
                    <Tooltip title="Select Time">
                      <AccessTimeIcon
                        onClick={() =>
                          handleTimeIconClick({ start: true, end: false })
                        }
                        className="cursor-pointer"
                      />
                    </Tooltip>
                  </span>
                </span>
                {calendarOpenStart && (
                  <div
                    ref={calendarRefStart}
                    className="calendar-datepicker"
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      backgroundColor: "white",
                      right: 260,
                      top: 68,
                      border: "1px solid grey",
                      borderRadius: "8px",
                      width: "290px",
                      height: "287px",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateCalendar
                        value={dayjs(value)}
                        onChange={(newValue) => {
                          setValue(new Date(newValue));
                          setSelectedRange({
                            ...selectedRange,
                            start: new Date(newValue),
                          });
                          setCalendarOpenStart(false);
                        }}
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </LocalizationProvider>
                  </div>
                )}
                {timePickerOpenStart && (
                  <div
                    ref={timePickerRefStart}
                    className="calendar-timepicker"
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      backgroundColor: "white",
                      top: 68,
                      left: 76,
                      border: "1px solid grey",
                      width: "178px",
                      height: "185px",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MultiSectionDigitalClock
                        value={dayjs(selectedRange?.start)}
                        sx={{
                          width: "100%",
                          height: "100%",
                          "& ul": {
                            overflowY: "scroll",
                          },
                        }}
                        onChange={(newValue) => {
                          setSelectedRange({
                            ...selectedRange,
                            start: new Date(
                              selectedRange?.start.setHours(
                                newValue.$H,
                                newValue.$m // Update hours and minutes
                              )
                            ),
                          });
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                )}
                <span style={inputWrapperStyle}>
                  <label style={labelStyle}>End Date & Time</label>
                  <input
                    type="text"
                    value={moment(selectedRange?.end).format(
                      "MM/DD/YYYY  h:mm A"
                    )}
                    readOnly
                    className="pl-2 py-2 pr-14 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg w-[100%] focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span style={iconStyle} className="mr-2 w-12">
                    <Tooltip title="Select Date">
                      <CalendarMonthIcon
                        onClick={() =>
                          handleIconClick({ start: false, end: true })
                        }
                        className="mr-1 cursor-pointer"
                      />
                    </Tooltip>
                    <Tooltip title="Select Time">
                      <AccessTimeIcon
                        onClick={() =>
                          handleTimeIconClick({ start: false, end: true })
                        }
                        className="cursor-pointer"
                      />
                    </Tooltip>
                  </span>
                </span>
                {calendarOpenEnd && (
                  <div
                    ref={calendarRefEnd}
                    className="calendar-datepicker"
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      backgroundColor: "white",
                      left: 220,
                      top: 68,
                      border: "1px solid grey",
                      borderRadius: "8px",
                      width: "290px",
                      height: "287px",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateCalendar
                        value={dayjs(value)}
                        onChange={(newValue) => {
                          setValue(new Date(newValue));
                          const selectedDate = new Date(newValue);
                          selectedDate.setHours(12, 0, 0, 0);
                          setSelectedRange({
                            ...selectedRange,
                            end: selectedDate,
                          });
                          setCalendarOpenEnd(false);
                        }}
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </LocalizationProvider>
                  </div>
                )}
                {timePickerOpenEnd && (
                  <div
                    ref={timePickerRefEnd}
                    className="calendar-timepicker"
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      backgroundColor: "white",
                      top: 68,
                      right: 10,
                      border: "1px solid grey",
                      width: "178px",
                      height: "185px",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MultiSectionDigitalClock
                        value={dayjs(selectedRange.end)}
                        sx={{
                          width: "100%",
                          height: "100%",
                          "& ul": {
                            overflowY: "scroll",
                          },
                        }}
                        onChange={(newValue) => {
                          setSelectedRange({
                            ...selectedRange,
                            end: new Date(
                              selectedRange.end.setHours(
                                newValue.$H,
                                newValue.$m // Update hours and minutes
                              )
                            ),
                          });
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                )}
              </div>
              <label className="px-2 text-sm font-semibold">
                <input
                  type="checkbox"
                  checked={isTemporary}
                  onChange={() => setIsTemporary(!isTemporary)}
                />
                &nbsp; <span className="text-center">Is temporary?</span>
              </label>
              <div className="flex justify-end mt-4 space-x-3">
                <button
                  onClick={() => closeModal({ isClearAll: false })}
                  // className="px-3 py-2 text-sm font-semibold text-white bg-gray-700 rounded-md"
                  className="text-sm font-semibold px-3 py-1 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmBooking}
                  // className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                  className="px-3 py-1 font-semibold text-sm text-white rounded-md  bg-primaryblue whitespace-nowrap border-[2px] border-primaryblue"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      {isEventModalOpen && selectedEvent && (
        <>
          {/* <span style={modalOverlayStyle}>
            <span style={modalStyle} className="calendar-availability">
              <span className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
                <span className="font-bold text-gray-800 text-md">
                  Availability Details
                </span>
                <Tooltip title="Close">
                  <button
                    onClick={() => {
                      closeEventModal();
                      setIsEdited(false);
                    }}
                  >
                    <CloseIcon />
                  </button>
                </Tooltip>
              </span>
              <div style={{ padding: "10px 10px 0px 10px" }}>
                {!selectedEvent?.isWeeklyEv && (
                  <span className="flex mb-2">
                    <div className="flex items-center space-x-6">
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="availability-single-day"
                          name="availability-type"
                          value="singleDay"
                          className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                          onChange={() => setEventAvailabilityType("singleDay")}
                          defaultChecked
                        />
                        <label
                          htmlFor="availability-single-day"
                          className="ml-2 text-sm font-medium text-gray-700"
                        >
                          Single Day Availability
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="availability-date-range"
                          name="availability-type"
                          value="dateRange"
                          className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                          onChange={() => setEventAvailabilityType("dateRange")}
                        />
                        <label
                          htmlFor="availability-date-range"
                          className="ml-2 text-sm font-medium text-gray-700"
                        >
                          Date Range Availability
                        </label>
                      </div>
                    </div>
                  </span>
                )}
                <span className="flex items-center mb-2">
                  <CalendarMonthIcon className="mr-2 text-gray-700" />
                  <p className="m-0 text-sm font-semibold text-gray-600">
                    {eventAvailabilityType === "dateRange" ? (
                      <>
                        {moment(selectedEvent.dates[0]).format("MMMM Do YYYY")} -{" "}
                        {moment(
                          selectedEvent.dates[selectedEvent.dates.length - 1]
                        ).format("MMMM Do YYYY")}
                      </>
                    ) : (
                      <>
                        {moment(selectedEvent.start).format("MMMM Do YYYY")} -{" "}
                        {moment(selectedEvent.end).format("MMMM Do YYYY")}
                      </>
                    )}
                  </p>
                </span>
                <span className="flex items-center mb-2">
                  <AccessTimeIcon className="mr-2 text-gray-700" />
                  <p className="m-0 text-sm font-semibold text-gray-600">
                    {moment(selectedEvent.start).format("h:mm A")} -{" "}
                    {moment(selectedEvent.end).format("h:mm A")}
                  </p>
                </span>
                {user?.permissions?.includes('provider_settings.edit_calendar_view_settings') && <span className="flex justify-end mt-3 space-x-3">
                  <button
                    className="px-3 py-2 text-sm font-semibold text-white bg-gray-700 rounded-md"
                    onClick={() => {
                      const [start, end] =
                        selectedEvent?.time_slots?.[0]?.split("-") || [];
                      setSelectedStartTime(start);
                      setSelectedEndTime(end);
                      setIsDeleteModalOpen(true);
                      setIsEventModalOpen(false);
                      if (eventAvailabilityType === "dateRange") {
                        setSelectedRange({
                          start: new Date(selectedEvent?.dates[0]),
                          end: new Date(
                            selectedEvent?.dates[selectedEvent?.dates?.length - 1]
                          ),
                        });
                      } else {
                        setSelectedRange({
                          start: selectedEvent?.start,
                          end: selectedEvent?.end,
                        });
                      }
                      setEventTitle(`${start}-${end}`);
                      setIsDelete(true);
                    }}
                  >
                    Delete
                  </button>

                  {(isEditableToShow || selectedEvent?.isWeeklyEv) && (
                    <button
                      onClick={() => {
                        if (selectedEvent?.isWeeklyEv) {
                          setIsEditConfirmationModalOpen(true);
                        } else {
                          setIsEventModalOpen(false);
                          const [start, end] =
                            selectedEvent?.time_slots?.[0]?.split("-") || [];

                          if (eventAvailabilityType === "dateRange") {
                            setSelectedRange({
                              start: new Date(selectedEvent?.dates[0]),
                              end: new Date(
                                selectedEvent?.dates[
                                selectedEvent?.dates?.length - 1
                                ]
                              ),
                            });
                          } else {
                            setSelectedRange({
                              start: selectedEvent?.start,
                              end: selectedEvent?.end,
                            });
                          }

                          setEventTitle(`${start}-${end}`);
                          setIsEdited({
                            status: true,
                            oldName: `${start}-${end}`,
                          });

                          if (isMultiDayAvailability) {
                            setSelectedStartTime(start);
                            setSelectedEndTime(end);
                            setSelectedAppointmentTypes(
                              selectedEvent?.appointment_type_ids || []
                            );
                            setSelectedZipCodes(selectedEvent?.zip_codes || []);
                            setSelectedZones([
                              ...new Set([
                                ...(selectedEvent?.zone_ids || []),
                                ...(providerDefaultZones || []),
                              ]),
                            ]);
                            setRegularDailySettings(false);
                            setIsMultiDayAvailabilityModalOpen(true);
                          }
                        }
                      }}
                      className="px-4 py-1 font-semibold text-sm text-white bg-primaryblue rounded-md border-[2px] border-primaryblue"
                    >
                      Edit
                    </button>
                  )}
                </span>}
              </div>
            </span>
          </span> */}

          {/* New Design */}
          <span style={modalOverlayStyle}>
            <span className="calendar-availability bg-white  py-2.5 rounded-lg shadow-md">

              <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800">Availability Details</h3>
                <Tooltip title="Close">
                  <button
                    onClick={() => {
                      closeEventModal();
                      setIsEdited(false);
                    }}
                    className="flex justify-center items-center w-8 h-8 text-gray-600 rounded-md hover:bg-gray-100"
                  >
                    <CloseIcon />
                  </button>
                </Tooltip>
              </div>
              <div className="px-4 py-2 w-[40vw]">
                <div className="mb-6">
                  <p className="mb-3 text-sm font-medium text-gray-600">Select Date Range</p>
                  <div className="flex gap-3 items-center">
                    <div className="flex-1">
                      <input
                        type="date"
                        id="startDate"
                        min={moment().format("YYYY-MM-DD")} // 🚫 Prevent past dates
                        // disabled={selectedEvent?.isWeeklyEv}
                        // value={selectedStartDate}
                        // value={moment(selectedEvent.start).format(
                        //   "YYYY-MM-DD"
                        // )}
                        value={moment(selectedRange?.start).format(
                          "YYYY-MM-DD"
                        )}
                        onChange={(e) => {
                          const selectedDate = moment(e.target.value, "YYYY-MM-DD").toDate();
                          selectedDate.setHours(12, 0, 0, 0);
                          setSelectedRange({
                            ...selectedRange,
                            start: selectedDate,
                          });
                        }}
                        className={`p-2 w-full text-sm rounded-md border border-gray-300 focus:border-blue-600 focus:ring-1 focus:ring-blue-200`}
                      />
                    </div>
                    <span className="text-sm text-gray-500">to</span>
                    <div className="flex-1">
                      <input
                        type="date"
                        id="endDate"
                        // disabled={selectedEvent?.isWeeklyEv}
                        // value={selectedEndDate}
                        // value={moment(selectedEvent.end).format(
                        //   "YYYY-MM-DD"
                        // )}
                        min={
                          moment(selectedRange?.start).isBefore(moment(), 'day')
                            ? moment().format('YYYY-MM-DD')
                            : moment(selectedRange?.start).format('YYYY-MM-DD')
                        }
                        value={moment(selectedRange?.end).format(
                          "YYYY-MM-DD"
                        )}
                        onChange={(e) => {
                          // const selectedDate = new Date(e.target.value);
                          const selectedDate = moment(e.target.value, "YYYY-MM-DD").toDate();
                          selectedDate.setHours(12, 0, 0, 0);
                          setSelectedRange({
                            ...selectedRange,
                            end: selectedDate,
                          });
                        }}
                        // onChange={(e) => handleDateChange("end", e.target.value)}
                        className={`p-2 w-full text-sm rounded-md border border-gray-300 focus:border-blue-600 focus:ring-1 focus:ring-blue-200`}
                      />
                    </div>
                  </div>
                  {/* <p className="mt-3 text-xs font-semibold text-gray-600">
                    {moment(selectedEvent.start).format("YYYY-MM-DD") == moment(selectedEvent.end).format("YYYY-MM-DD")
                      ? `Single date selected: ${moment(selectedEvent.start)?.format("MMMM Do YYYY")}`
                      : `${daysSelected} days selected: ${moment(selectedEvent.start)} - ${moment(selectedEvent.end)}`}
                  </p> */}
                  <p className="mt-3 text-xs font-semibold text-gray-600">
                    {moment(selectedRange?.start).isSame(moment(selectedRange?.end), "day")
                      ? `Single date selected: ${moment(selectedRange?.start).format("MMMM Do YYYY")}`
                      : `${moment(selectedRange?.start).diff(moment(selectedRange?.end), "days") === -1
                        ? `1 day selected: ${moment(selectedRange?.start).format("MMMM Do YYYY")} - ${moment(selectedRange?.end).format("MMMM Do YYYY")}`
                        : `${moment(selectedRange?.end).diff(moment(selectedRange?.start), "days") + 1
                        } days selected: ${moment(selectedRange?.start).format("MMMM Do YYYY")} - ${moment(selectedRange?.end).format("MMMM Do YYYY")}`
                      }`}
                  </p>
                </div>

                <div className="flex gap-2 items-center mb-2 text-gray-700">
                  <AccessTimeIcon className="text-gray-600" />
                  <span className="text-base font-medium">
                    {moment(selectedEvent.start).format("h:mm A")} -{" "}
                    {moment(selectedEvent.end).format("h:mm A")}
                  </span>
                </div>
                {!selectedEvent?.isWeeklyEv && displayRange && (() => {
                  const currentAssignment = displayRange.assignments?.find((a) => {
                    const start = moment(a.start_date);
                    const end = moment(a.end_date);
                    const selectedStart = moment(selectedRange?.start);
                    const selectedEnd = moment(selectedRange?.end);

                    // Check if selected date range overlaps with assignment date range
                    const isWithinRange =
                      selectedStart.isBetween(start, end, undefined, "[]") ||
                      selectedEnd.isBetween(start, end, undefined, "[]");

                    if (!isWithinRange) return false;

                    // Now check if any of the selected dates are in deleted_dates
                    const selectedDates = [];
                    let currentDate = selectedStart.clone();

                    // Generate all dates in the selected range
                    while (currentDate.isSameOrBefore(selectedEnd, "day")) {
                      selectedDates.push(currentDate.format("YYYY-MM-DD"));
                      currentDate.add(1, "day");
                    }

                    // Check if ALL selected dates are in deleted_dates
                    const deletedDates = a.deleted_dates || [];
                    const allDatesDeleted = selectedDates.every(date =>
                      deletedDates.includes(date)
                    );

                    // Return false if all dates are deleted (don't show the message)
                    return !allDatesDeleted;
                  });

                  if (!currentAssignment) return null;

                  // Optional: Show which specific dates are not deleted
                  const selectedDates = [];
                  let currentDate = moment(selectedRange?.start);
                  const selectedEndMoment = moment(selectedRange?.end);

                  while (currentDate.isSameOrBefore(selectedEndMoment, "day")) {
                    selectedDates.push(currentDate.format("YYYY-MM-DD"));
                    currentDate.add(1, "day");
                  }

                  const deletedDates = currentAssignment.deleted_dates || [];
                  const nonDeletedDates = selectedDates.filter(date =>
                    !deletedDates.includes(date)
                  );

                  return (
                    <div className="p-3 mb-4 bg-blue-50 rounded-md border border-blue-200">
                      <p className="mb-1 text-xs font-semibold text-gray-600 uppercase">
                        Part of Settings
                      </p>
                      <p className="text-sm text-gray-800">
                        <b>{displayRange?.template_name}</b>'s assigned date range
                        {nonDeletedDates.length < selectedDates.length && (
                          <span className="block mt-1 text-xs text-gray-600">
                            Note: Some selected dates are excluded from this template
                          </span>
                        )}
                      </p>
                      <span className="inline-block mt-2 bg-blue-100 text-blue-700 text-[11px] font-semibold px-2 py-0.5 rounded-full">
                        CUSTOM TEMPLATE
                      </span>
                    </div>
                  );
                })()}

                {user?.permissions?.includes("provider_settings.edit_calendar_view_settings") && (
                  <div className="flex gap-3">
                    <button
                      // onClick={handleDeleteAvailability}
                      className="flex-1 py-2 text-sm font-semibold text-white bg-gray-700 rounded-md transition hover:bg-gray-800"

                      onClick={() => {
                        const [rawStart, rawEnd] = selectedEvent?.time_slots?.[0]?.split("-") || [];

                        // Normalize to HH:mm format
                        const start = moment(rawStart.trim(), ["H:mm", "HH:mm"]).format("HH:mm");
                        const end = moment(rawEnd.trim(), ["H:mm", "HH:mm"]).format("HH:mm");
                        setSelectedStartTime(start);
                        setSelectedEndTime(end);
                        setIsDeleteModalOpen(true);
                        setIsEventModalOpen(false);
                        // if (eventAvailabilityType === "dateRange") {
                        //   // setSelectedRange({
                        //   //   start: new Date(selectedEvent?.dates[0]),
                        //   //   end: new Date(
                        //   //     selectedEvent?.dates[selectedEvent?.dates?.length - 1]
                        //   //   ),
                        //   // });
                        // } else {
                        //   // setSelectedRange({
                        //   //   start: selectedEvent?.start,
                        //   //   end: selectedEvent?.end,
                        //   // });
                        // }
                        setEventTitle(`${start}-${end}`);
                        setIsDelete(true);
                      }}
                    >
                      Delete
                    </button>
                    <button
                      // onClick={handleEditAvailability}
                      className="flex-1 py-2 text-sm font-semibold text-white bg-blue-600 rounded-md transition hover:bg-blue-700"
                      onClick={() => {

                        // if (selectedEvent?.isWeeklyEv) {
                        //   setIsEditConfirmationModalOpen(true);
                        // } else {
                        const hasLeaveConflict = mergedEvents.some(event => {
                          if (!event.isLeave) return false;
                          const leaveStart = moment(event.start);
                          const leaveEnd = moment(event.end);
                          // Check if start or end (or in between) falls inside the leave range
                          return (
                            moment(selectedRange?.start).isBetween(leaveStart, leaveEnd, "day", "[]") ||
                            moment(selectedRange?.end).isBetween(leaveStart, leaveEnd, "day", "[]") ||
                            moment(leaveStart).isBetween(selectedRange?.start, selectedRange?.end, "day", "[]") ||
                            moment(leaveEnd).isBetween(selectedRange?.start, selectedRange?.end, "day", "[]")
                          );
                        });
                        if (hasLeaveConflict) {
                          showAlert("Selected dates include leave days. Please choose different dates.", "info");
                          return;
                        }
                        setIsEventModalOpen(false);
                        const [rawStart, rawEnd] = selectedEvent?.time_slots?.[0]?.split("-") || [];

                        // Normalize to HH:mm format
                        const start = moment(rawStart.trim(), ["H:mm", "HH:mm"]).format("HH:mm");
                        const end = moment(rawEnd.trim(), ["H:mm", "HH:mm"]).format("HH:mm");


                        // if (eventAvailabilityType === "dateRange") {
                        //   setSelectedRange({
                        //     start: new Date(selectedEvent?.dates[0]),
                        //     end: new Date(
                        //       selectedEvent?.dates[
                        //       selectedEvent?.dates?.length - 1
                        //       ]
                        //     ),
                        //   });
                        // } else {
                        //   setSelectedRange({
                        //     start: selectedEvent?.start,
                        //     end: selectedEvent?.end,
                        //   });
                        // }
                        setEventTitle(`${start}-${end}`);
                        setIsEdited({
                          status: true,
                          oldName: `${start}-${end}`,
                        });

                        // if (isMultiDayAvailability) {
                        setSelectedStartTime(start);
                        setSelectedEndTime(end);
                        setSelectedAppointmentTypes(
                          selectedEvent?.appointment_type_ids ?? dayPreferences?.ALL?.appointment_type_ids ?? []
                        );
                        setSelectedZipCodes(
                          selectedEvent?.zip_codes ?? dayPreferences?.ALL?.zip_codes ?? []
                        );
                        // setSelectedZipCodes(selectedEvent?.zip_codes || []);
                        setSelectedZones([
                          ...new Set([
                            ...(selectedEvent?.zone_ids || []),
                            ...(providerDefaultZones || []),
                          ]),
                        ]);
                        setRegularDailySettings(false);
                        setIsMultiDayAvailabilityModalOpen(true);
                        // }
                        // }
                      }}
                    >
                      Edit
                    </button>
                  </div>
                )}

                <p className="pt-3 mt-4 text-xs text-center text-gray-400 border-t border-gray-200">
                  Actions will apply to the selected date only
                </p>
              </div>
            </span>
          </span>
        </>
      )}
      {isDeleteModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
              <span className="font-bold text-gray-800 text-md">
                Delete Availability
              </span>
              <Tooltip title="Close">
                <button
                  onClick={() => {
                    setIsDeleteModalOpen(false);
                    setSelectedEvent(null);
                  }}
                >
                  <CloseIcon />
                </button>
              </Tooltip>
            </div>
            <span
              className="flex-col d-flex"
              style={{ padding: "10px 10px 0px 10px " }}
            >
              <p>{selectedEvent?.isWeeklyEv ? "The selected date(s) is part of global availability. Are you sure you want to delete this availability ?" : "Are you sure you want to delete this availability ?"}</p>
              <div className="gap-1 justify-end d-flex">
                {<button
                  onClick={() => {
                    // const event = events?.filter(
                    //   (item) => item?.id !== selectedEvent?.id
                    // );
                    // setEvents(event);
                    setIsEventModalOpen(false);
                    setIsDeleteModalOpen(false);
                    if (selectedEvent?.isWeeklyEv) {
                      deleteWeeklyEvent();
                    } else {
                      saveMultiDayAvailability();
                    }
                  }}
                  className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                >
                  Delete
                </button>}
              </div>
            </span>
          </div>
        </div>
      )}
      {isConfirmationModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
              <span className="font-bold text-gray-800 text-md">
                Confirm Availability Creation
              </span>
              <Tooltip title="Close">
                <button
                  onClick={() => {
                    setIsConfirmationModalOpen(false);
                    setIsTimeSlotSelect(false);
                  }}
                >
                  <CloseIcon />
                </button>
              </Tooltip>
            </div>
            <span
              className="flex-col d-flex"
              style={{ padding: "10px 10px 0px 10px " }}
            >
              <p>
                There are existing Availabilities on this date. Are you sure you
                want to proceed?
              </p>
              <p className="mb-2 text-sm font-semibold">
                Available Availabilities Details
              </p>
              {/* <div className='max-h-[150px] overflow-auto custom-scrollbar'>
                                {eventDetails.map((event, index) => (
                                    <div key={index}>
                                        <p className='m-0 text-xs'>
                                            <strong>{event.title}</strong> :
                                            {moment(event.start).format('Do MMMM, YYYY h:mm A')} -
                                            {moment(event.end).format('h:mm A')}
                                        </p>
                                    </div>
                                ))}
                            </div> */}
              <div className="max-h-[150px] overflow-auto custom-scrollbar">
                {Object.entries(groupedEvents).map(([title, events]) => (
                  <div key={title}>
                    <p className="m-0 text-xs">
                      <strong>{title}</strong>:
                    </p>
                    <ul className="pl-5 list-disc">
                      {events.map((event, index) => (
                        <li key={index} className="m-0 text-xs">
                          {moment(event.start).format("Do MMMM, YYYY h:mm A")} -
                          {moment(event.end).format("h:mm A")}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <div className="gap-2 justify-end mt-3 d-flex">
                <button
                  onClick={() => {
                    setIsConfirmationModalOpen(false);
                    setIsTimeSlotSelect(false);
                  }}
                  className="px-3 py-1 font-semibold text-sm  border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setIsConfirmationModalOpen(false);
                    setSelectedRange({
                      start: newRange.start,
                      end: moment(newRange.end).subtract(1, "seconds").toDate(),
                    });
                    setEventTitle("");
                    if (!isMultiDayAvailability) {
                      setIsCalendarOpen(true);
                    } else {
                      setIsMultiDayAvailabilityModalOpen(true);
                    }
                  }}
                  className="px-3 py-1 text-sm font-semibold text-white rounded-md bg-primaryblue"
                >
                  Proceed
                </button>
              </div>
            </span>

          </div>
        </div>
      )}

      {isMultiDayAvailabilityModalOpen && (
        <div className="p-4 bg-white">
          {/* Multi-Day Modal */}
          <div className="flex fixed inset-0 top-0 right-0 bottom-0 left-0 z-50 justify-center items-center w-screen h-screen bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-6 w-[60vw] h-[80vh] overflow-auto">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold">
                  Set Multi-Day Availability
                </h3>
                <button
                  onClick={() => setIsMultiDayAvailabilityModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg
                    xmlns="<http://www.w3.org/2000/svg>"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              {!selectedEvent?.isWeeklyEv && (
                <>
                  {/* Date Range Selection */}
                  {/* <div className="p-4 mb-6 bg-blue-50 rounded-lg border border-blue-100">
                    <h4 className="mb-4 text-lg font-medium text-blue-800">
                      Select Date Range
                    </h4>

                    <div className="grid grid-cols-2 gap-6 mb-4">
                      <div>
                        <label className="block mb-1 text-sm font-medium text-gray-700">
                          Start Date
                        </label>
                        <div className="flex">
                          <input
                            type="date"
                            value={moment(selectedRange?.start).format(
                              "YYYY-MM-DD"
                            )}
                            onChange={(e) => {
                              const selectedDate = new Date(e.target.value);
                              selectedDate.setHours(12, 0, 0, 0);
                              setSelectedRange({
                                ...selectedRange,
                                start: selectedDate,
                              });
                            }}
                            className="p-2 w-full rounded-l border border-gray-300"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block mb-1 text-sm font-medium text-gray-700">
                          End Date
                        </label>
                        <div className="flex">
                          <input
                            type="date"
                            value={moment(selectedRange?.end).format(
                              "YYYY-MM-DD"
                            )}
                            onChange={(e) => {
                              const selectedDate = new Date(e.target.value);
                              selectedDate.setHours(12, 0, 0, 0);
                              setSelectedRange({
                                ...selectedRange,
                                end: selectedDate,
                              });
                            }}
                            className="p-2 w-full rounded-l border border-gray-300"
                          />
                        </div>
                      </div>
                    </div>

                    

                    <div className="p-3 text-sm text-gray-600 bg-yellow-50 rounded-lg border border-yellow-200">
                      <p className="mb-1 font-medium text-yellow-800">
                        Selection Summary:
                      </p>
                      {selectedRange?.start && selectedRange?.end && (
                        <p>
                          This will set availability for{" "}
                          <strong>
                            {moment(selectedRange.start).format("MM/DD/YYYY")}-
                            {moment(selectedRange.end).format("MM/DD/YYYY")}
                          </strong>{" "}
                          (
                          {(() => {
                            const diff =
                              moment(selectedRange.end).diff(
                                moment(selectedRange.start),
                                "days"
                              ) + 1;
                            return `${diff} ${diff === 1 ? "day" : "days"}`;
                          })()}
                          ).
                        </p>
                      )}
                    </div>
                  </div> */}
                </>
              )}
              {/* Time Selection */}

              <div className="mb-6">
                <h4 className="mb-4 text-lg font-medium">Set Working Hours</h4>

                <div className="grid grid-cols-2 gap-6 mb-4">
                  <div>
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                      Start Time
                    </label>
                    <select
                      className="p-2 w-full rounded border border-gray-300"
                      value={selectedStartTime}
                      onChange={(e) => {
                        setSelectedStartTime(e.target.value);
                      }}
                    >
                      {Array.from({ length: 48 }, (_, i) => {
                        const hours = String(Math.floor(i / 2)).padStart(
                          2,
                          "0"
                        );
                        const minutes = i % 2 === 0 ? "00" : "30";
                        const time = `${hours}:${minutes}`;
                        return (
                          <option key={time} value={time}>
                            {moment(time, "HH:mm").format("hh:mm A")}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div>
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                      End Time
                    </label>
                    <select
                      className="p-2 w-full rounded border border-gray-300"
                      value={selectedEndTime}
                      onChange={(e) => {
                        setSelectedEndTime(e.target.value);
                      }}
                    >
                      {Array.from({ length: 48 }, (_, i) => {
                        const hours = String(Math.floor(i / 2)).padStart(
                          2,
                          "0"
                        );
                        const minutes = i % 2 === 0 ? "00" : "30";
                        const time = `${hours}:${minutes}`;
                        return (
                          <option key={time} value={time}>
                            {moment(time, "HH:mm").format("hh:mm A")}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    id="copy-daily-settings"
                    className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                    checked={regularDailySettings}
                    onChange={(e) => {
                      setRegularDailySettings(e.target.checked);
                    }}
                  />
                  <label
                    htmlFor="copy-daily-settings"
                    className="ml-2 text-gray-700"
                  >
                    Use this provider's regular daily settings for appointment
                    types and geographic coverage
                  </label>
                </div>
              </div>

              {/* Custom Settings */}
              <div className="p-4 mb-6 bg-gray-50 rounded-lg border border-gray-200">
                <h4 className="mb-4 text-lg font-medium">
                  Custom Settings (Optional)
                </h4>

                <div className="mb-6">
                  <h5 className="mb-2 text-base font-semibold text-gray-700 text-md">
                    Appointment Types for these dates:
                  </h5>
                  <div className="flex items-center mb-2">
                    <input
                      type="checkbox"
                      id="select-all-types"
                      className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                      checked={
                        selectedAppointmentTypes?.length ===
                        appointmentTypes.length
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedAppointmentTypes(
                            appointmentTypes.map((type) => type.id)
                          );
                        } else {
                          setSelectedAppointmentTypes([]);
                        }
                      }}
                    />
                    <label
                      htmlFor="select-all-types"
                      className="ml-2 text-sm font-medium text-gray-700"
                    >
                      Select all
                    </label>
                  </div>
                  <div className="grid grid-cols-3 gap-2">
                    {appointmentTypes.map((type) => (
                      <div key={type.id} className="flex items-center">
                        <input
                          type="checkbox"
                          id={`multi-type-${type.id}`}
                          className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                          checked={
                            selectedAppointmentTypes?.includes(type.id) || false
                          }
                          onChange={(e) => {
                            setSelectedAppointmentTypes((prev) => {
                              const prevTypes = prev || [];
                              if (e.target.checked) {
                                return [...prevTypes, type.id];
                              } else {
                                return [
                                  ...prevTypes.filter((id) => id !== type.id),
                                ];
                              }
                            });
                          }}
                        />
                        <label
                          htmlFor={`multi-type-${type.id}`}
                          className="ml-2 text-sm text-gray-700"
                        >
                          {type.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                {/* <GeographicCoverageSection
                  // selectedDay={daysSelected}
                  selectedDay={new Date(selectedRange?.start)
                    .toLocaleString('en-US', { weekday: 'long' })
                    .toUpperCase() || "ALL"}
                  dayPreferences={selectedEvent?.isWeeklyEv ? dayPreferences : matchingRange?.day_preferences || dayPreferences}
                  setDayPreferences={setDayPreferences}
                  providerId={provideIdAv}
                  fetchProviderZipCodes={fetchProviderZipCodes}
                  disabled={
                    !user?.permissions?.includes(
                      "provider_settings.edit_weekly_settings"
                    )
                  }
                /> */}

                <div className="mb-6">
                  <ReusableModal
                    open={showZipModal?.status}
                    title="Coverage"
                    onClose={() => {
                      setShowZipModal({ status: false, zips: [] })
                    }}
                  >
                    <div className="min-w-[45vw] max-w-[45vw] p-3 ">
                      <h2 className="mb-3 text-lg font-semibold">Zip Codes</h2>
                      <div
                        className="text-gray-700 max-h-[400px] overflow-y-auto p-2 rounded-md border border-gray-200 bg-gray-50"
                      >
                        {selectedZipCodes.length > 0 ? (
                          <p className="leading-relaxed whitespace-normal break-words">
                            {Array.from(selectedZipCodes).join(", ")}

                          </p>
                        ) : (
                          <p className="italic text-gray-500">No Zip codes available.</p>
                        )}
                      </div>
                    </div>
                  </ReusableModal>
                  <h3 className="mb-4 text-base font-semibold">
                    Geographic Coverage{" "}
                    {/* {selectedDay !== "ALL"
                      ? `for ${selectedDay[0] + selectedDay.substring(1).toLowerCase()}`
                      : ""} */}
                  </h3>
                  <div className="bg-[#4285f4] text-white px-4 py-2 rounded-md text-sm font-semibold mb-3">
                    Custom Coverage
                  </div>
                  <div className="px-3 py-2 mb-3 bg-blue-50 rounded-lg border border-blue-200">
                    <div className="mb-1 text-sm font-semibold text-blue-800">
                      Selected Coverage
                    </div>
                    <div className="text-sm text-blue-600">
                      {selectedZipCodes.length === 0
                        ? "No zip codes selected"
                        : selectedZipCodes.length === allZipCodes.size
                          ? `All ${selectedZipCodes.length} zip codes selected`
                          : `${selectedZipCodes.length} of ${allZipCodes.size} zip codes selected`}
                    </div>
                    {selectedZipCodes.length > 0 && (
                      <div className="flex flex-wrap gap-1 mt-2">
                        {Array.from(selectedZipCodes)
                          .slice(0, 5)
                          .map((zip) => (
                            <span
                              key={zip}
                              className="inline-flex items-center px-2 py-1 text-xs text-blue-800 bg-blue-100 rounded-full"
                            >
                              {zip}
                            </span>
                          ))}
                        {selectedZipCodes.length > 5 && (
                          <span className="text-xs text-blue-600 cursor-pointer" onClick={() => {
                            setShowZipModal({ status: true })
                          }}>
                            +{selectedZipCodes.length - 5} more
                          </span>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="space-y-4">
                    <div>
                      <input
                        type="text"
                        disabled={
                          !user?.permissions?.includes(
                            "provider_settings.edit_weekly_settings"
                          )}
                        className="px-3 py-2 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Search zip codes or cities..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>

                    <div className="px-3 py-2 bg-gray-50 rounded-lg border border-gray-300">
                      <label className="flex gap-2 items-center text-sm font-medium text-gray-700 cursor-pointer">
                        <input
                          type="checkbox"
                          disabled={
                            !user?.permissions?.includes(
                              "provider_settings.edit_weekly_settings"
                            )}
                          className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                          checked={isAllSelected}
                          ref={(el) => {
                            if (el) {
                              el.indeterminate = isSomeSelected;
                            }
                          }}
                          onChange={(e) => handleSelectAll(e.target.checked)}
                        />
                        Select all zip codes
                      </label>
                    </div>

                    <div className="overflow-y-auto max-h-80 bg-white rounded-lg border border-gray-300">
                      {isLoading ? (
                        <div className="py-8 text-center text-gray-500">
                          <div className="flex flex-col gap-2 items-center">
                            <div className="w-8 h-8 rounded-full border-4 border-blue-600 animate-spin border-t-transparent"></div>
                            <span>Loading coverage data...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          {filteredData(coverageData).map((item) => renderTreeItem(item))}

                          {filteredData(coverageData).length === 0 && (
                            <div className="py-8 text-center text-gray-500">
                              No matching zip codes found
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div>
                  <h5 className="mb-2 font-medium text-gray-700 text-md">
                    Geographic Coverage:
                  </h5>
                  <div className="flex mb-2">
                    <button
                      onClick={() => setSelectedCoverage("default")}
                      className={`px-3 py-1 text-sm rounded-l ${selectedCoverage === "default"
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200 text-gray-700"
                        }`}
                    >
                      Use Default Coverage
                    </button>
                    <button
                      onClick={() => setSelectedCoverage("custom")}
                      className={`px-3 py-1 text-sm rounded-r ${selectedCoverage === "custom"
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200 text-gray-700"
                        }`}
                    >
                      Custom Coverage
                    </button>
                  </div>
                  {selectedCoverage === "default" && (
                    <p className="mb-0 text-sm text-gray-600">
                      Using provider's default coverage settings
                    </p>
                  )}
                  {selectedCoverage === "custom" && (
                    <div className="mt-4">
                      <div className="flex mb-4">
                        <button
                          className={`px-4 py-2 font-medium rounded-l ${selectedTab === "zip"
                            ? "bg-blue-600 text-white"
                            : "bg-gray-200 text-gray-700"
                            }`}
                          onClick={() => {
                            setSelectedTab("zip");
                            // setIsZipCodeModalOpen(true);
                          }}
                        >
                          Zip Codes
                        </button>
                        <button
                          className={`px-4 py-2 font-medium rounded-r ${selectedTab === "zone"
                            ? "bg-blue-600 text-white"
                            : "bg-gray-200 text-gray-700"
                            }`}
                          onClick={() => {
                            setSelectedTab("zone");
                          }}
                        >
                          Zones
                        </button>
                      </div>

                      {selectedTab === "zone" && (
                        <Select
                          options={zones
                            ?.map((e) => ({
                              value: e.id,
                              label: e?.name,
                              isFixed: providerDefaultZones?.includes(e.id),
                            }))
                            ?.sort((a, b) => a?.label?.localeCompare(b?.label))}
                          isMulti
                          value={zones
                            ?.filter((zone) => selectedZones?.includes(zone.id))
                            .map((zone) => ({
                              value: zone.id,
                              label: zone.name,
                              isFixed: providerDefaultZones?.includes(zone.id),
                            }))}
                          onChange={(
                            selectedZones,
                            { removedValue, action }
                          ) => {
                            if (
                              action === "remove-value" &&
                              removedValue?.isFixed
                            ) {
                              return;
                            }

                            const finalSelectedZones = [
                              ...(selectedZones || []),
                            ];
                            const defaultZoneIds = providerDefaultZones || [];

                            defaultZoneIds?.forEach((defaultZoneId) => {
                              if (
                                !finalSelectedZones.find(
                                  (zone) => zone.value === defaultZoneId
                                )
                              ) {
                                const defaultZone = zones?.find(
                                  (z) => z.id === defaultZoneId
                                );
                                if (defaultZone) {
                                  finalSelectedZones.push({
                                    value: defaultZone.id,
                                    label: defaultZone.name,
                                    isFixed: true,
                                  });
                                }
                              }
                            });

                            setSelectedZones(
                              finalSelectedZones.map((z) => z.value)
                            );
                          }}
                          styles={{
                            multiValue: (base, { data }) => ({
                              ...base,
                              backgroundColor: data.isFixed
                                ? "#e2e8f0"
                                : base.backgroundColor,
                              padding: "2px",
                            }),
                            multiValueLabel: (base, { data }) => ({
                              ...base,
                              padding: data.isFixed ? "3px 6px" : base.padding,
                            }),
                            multiValueRemove: (base, { data }) => ({
                              ...base,
                              display: data.isFixed ? "none" : base.display,
                            }),
                          }}
                          placeholder="Select zones..."
                          className="w-full"
                          menuPlacement="top"
                          isClearable={false}
                        />
                      )}
                      {selectedTab === "zip" && (
                        <Select
                          options={zipCodes
                            ?.map((e) => ({
                              value: e,
                              label: e,
                            }))
                            ?.sort(
                              (a, b) => parseInt(a?.label) - parseInt(b?.label)
                            )}
                          isMulti
                          value={zipCodes
                            ?.filter((zip) => selectedZipCodes?.includes(zip))
                            .map((zip) => ({
                              value: zip,
                              label: zip,
                            }))}
                          onChange={(e) => {
                            setSelectedZipCodes(e?.map((z) => z.value));
                          }}
                          placeholder="Select zip codes..."
                          className="w-full"
                          menuPlacement="top"
                        />
                      )}
                    </div>
                  )}
                  <div className="flex flex-wrap gap-2 pt-4 my-2">
                    {zones
                      .filter((z) => selectedZones?.includes(z.id))
                      .map((z) => (
                        <div
                          key={z.id}
                          className="flex items-center px-3 py-1 bg-blue-100 rounded-full"
                        >
                          <span className="text-blue-800">{z.name}</span>
                          {!providerDefaultZones?.includes(z.id) && (
                            <button
                              className="ml-2 text-blue-600 hover:text-blue-800"
                              onClick={() => {
                                setSelectedZones((prev) => {
                                  return prev.filter((id) => id !== z.id);
                                });
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                              </svg>
                            </button>
                          )}
                        </div>
                      ))}
                    {zipCodes
                      .filter((z) => selectedZipCodes?.includes(z))
                      .map((z) => (
                        <div
                          key={z}
                          className="flex items-center px-3 py-1 bg-blue-100 rounded-full"
                        >
                          <span className="text-blue-800">{z}</span>
                          <button
                            className="ml-2 text-blue-600 hover:text-blue-800"
                            onClick={() => {
                              setSelectedZipCodes((prev) => {
                                return prev.filter((code) => code !== z);
                              });
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                          </button>
                        </div>
                      ))}
                  </div>
                </div> */}
              </div>

              <div className="flex gap-4 justify-end">
                <button
                  onClick={() => setIsMultiDayAvailabilityModalOpen(false)}
                  className="px-6 py-2 font-medium text-blue-600 rounded border border-blue-600"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    if (selectedEvent?.isWeeklyEv) {
                      // setDayPreferences((prev) => {
                      //   const dayPref = {
                      //     ...prev,
                      //     [selectedEvent.day]: {
                      //       ...prev[selectedEvent.day],
                      //       working_hours: {
                      //         ...prev[selectedEvent.day]?.working_hours,
                      //         start: getEstTimezoneTime(
                      //           moment(selectedRange.start).format(
                      //             "YYYY-MM-DD"
                      //           ),
                      //           selectedStartTime,
                      //           providerTimezone
                      //         ),
                      //         end: getEstTimezoneTime(
                      //           moment(selectedRange.end).format("YYYY-MM-DD"),
                      //           selectedEndTime,
                      //           providerTimezone
                      //         ),
                      //       },
                      //       appointment_type_ids: selectedAppointmentTypes,
                      //       zone_ids: selectedZones,
                      //       zip_codes: selectedZipCodes,
                      //     },
                      //   };
                      //   return dayPref;
                      // });
                      // setUpdateWeeklySettings(true);
                      // setIsMultiDayAvailabilityModalOpen(false);
                      // saveMultiDayAvailability(selectedEvent?.isWeeklyEv);
                      setIsSaveConfirmationModalOpen({ status: true, isWeeklyEv: selectedEvent?.isWeeklyEv, message: "The selected date(s) is part of global availability." })
                    } else {
                      // saveMultiDayAvailability();
                      setIsSaveConfirmationModalOpen({ status: true, message: "Saving this custom availability will override existing settings for the selected date(s)." })
                    }
                  }}
                  className="px-6 py-2 font-medium text-white bg-blue-600 rounded"
                >
                  Save Multi-Day Availability
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Absence Details Modal */}
      {isLeaveModalOpen && selectedEvent && (
        <div style={modalOverlayStyle}>
          <div
            style={{ ...modalStyle, width: "360px" }}
            className="calendar-availability"
          >
            <div className="px-2 py-2 bg-white rounded-t border-b d-flex justify-content-between align-items-center">
              <span className="text-lg font-bold text-gray-800">
                Absence Details
              </span>
              <Tooltip title="Close">
                <button
                  onClick={() => {
                    setIsLeaveModalOpen(false);
                    setSelectedEvent(null);
                  }}
                  className="text-gray-500 transition-colors hover:text-gray-700"
                >
                  <CloseIcon />
                </button>
              </Tooltip>
            </div>
            <div className="px-2 py-3">
              {/* Absence Type Header */}
              <div
                className={`p-2 mb-3 bg-red-50 rounded-lg border border-red-100`}
              >
                <div className="flex items-center">
                  <div
                    className={`mr-2 w-2 h-2 bg-red-500 rounded-full`}
                  />
                  <span
                    className={`text-sm font-semibold text-red-700`}
                  >
                    {/* {selectedEvent.leaveType === "GEN" ? "Unpaid Absence" : "PTO"} */}
                    {selectedEvent.title.split(":")[1].split("(")[0].trim()}
                  </span>
                </div>
              </div>

              {/* Absence Details */}
              <div className="space-y-3">
                {/* Absence Name */}
                {/* <div>
                  <label className="block mb-1 text-xs font-medium text-gray-500">
                    Absence Name
                  </label>
                  <p className="text-sm font-bold text-gray-900">
                    {selectedEvent.title.split(":")[1].split("(")[0].trim()}
                  </p>
                </div> */}

                {/* Duration */}
                <div>
                  <label className="block mb-1 text-xs font-medium text-gray-500">
                    Duration
                  </label>
                  <div className="flex items-start p-3 mb-3 bg-gray-50 rounded-lg">
                    <CalendarMonthIcon
                      className="mr-3 text-gray-400"
                      fontSize="small"
                    />
                    <div className="space-y-1">
                      <div className="flex items-center text-sm">
                        <span className="mr-1 w-12 text-gray-500">Start:</span>
                        <span className="font-medium text-gray-900">
                          {moment(selectedEvent.start).format("MMM D, YYYY")}
                          {selectedEvent.startTime ? `, ${moment(selectedEvent.startTime, "HH:mm").format("hh:mm A")}` : ""}
                        </span>
                      </div>
                      <div className="flex items-center text-sm">
                        <span className="mr-1 w-12 text-gray-500">End:</span>
                        <span className="font-medium text-gray-900">
                          {moment(selectedEvent.end).format("MMM D, YYYY")}
                          {selectedEvent.endTime ? `, ${moment(selectedEvent.endTime, "HH:mm").format("hh:mm A")}` : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Total Days & Status */}
                <div className="flex justify-between items-center">
                  <div>
                    <label className="block mb-1 text-xs font-medium text-gray-500">
                      Total Days
                    </label>
                    <div className="flex items-center">
                      <span className="text-lg font-bold text-gray-900">
                        {moment(selectedEvent.end).diff(
                          moment(selectedEvent.start),
                          "days"
                        ) + 1}
                      </span>
                      <span className="ml-1 text-sm text-gray-600">days</span>
                    </div>
                  </div>

                  <div>
                    <label className="block mb-1 text-xs font-medium text-gray-500">
                      Status
                    </label>
                    <div className="flex items-center">
                      <div
                        className={`w-2 h-2 rounded-full mr-1.5 ${moment().isBetween(
                          selectedEvent.start,
                          selectedEvent.end,
                          "day",
                          "[]"
                        )
                          ? "bg-green-500"
                          : moment().isBefore(selectedEvent.start)
                            ? "bg-blue-500"
                            : "bg-gray-500"
                          }`}
                      />
                      <span
                        className={`text-xs font-medium ${moment().isBetween(
                          selectedEvent.start,
                          selectedEvent.end,
                          "day",
                          "[]"
                        )
                          ? "text-green-700"
                          : moment().isBefore(selectedEvent.start)
                            ? "text-blue-700"
                            : "text-gray-700"
                          }`}
                      >
                        {moment().isBetween(
                          selectedEvent.start,
                          selectedEvent.end,
                          "day",
                          "[]"
                        )
                          ? "Active"
                          : moment().isBefore(selectedEvent.start)
                            ? "Upcoming"
                            : "Completed"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-end mt-4">
                <button
                  onClick={() => {
                    setIsLeaveModalOpen(false);
                    setSelectedEvent(null);
                  }}
                  className="px-3 py-1.5 text-sm font-medium text-white bg-gray-600 rounded hover:bg-gray-700 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isEditConfirmationModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
              <span className="font-bold text-gray-800 text-md">
                Edit Weekly Availability
              </span>
              <Tooltip title="Close">
                <button
                  onClick={() => {
                    setIsEditConfirmationModalOpen(false);
                    // setSelectedEvent(null);
                  }}
                >
                  <CloseIcon />
                </button>
              </Tooltip>
            </div>
            <span
              className="flex-col d-flex"
              style={{ padding: "10px 10px 0px 10px " }}
            >
              {/* <p>
                This will update weekly settings for{" "}
                <b>
                  {selectedEvent?.day?.charAt(0)?.toUpperCase() +
                    selectedEvent?.day?.slice(1)?.toLowerCase()}
                </b>
                . <br />
                Are you sure you want to proceed?
              </p> */}
              <p className="text-sm leading-relaxed text-gray-700">
                This will update all{" "}
                <b>
                  {selectedEvent?.day
                    ? selectedEvent?.day.charAt(0).toUpperCase() +
                    selectedEvent?.day.slice(1).toLowerCase() + "s"
                    : ""}
                </b>{" "}
                covered in the date range{" "}
                <b>

                  {moment(selectedRange?.start).format("Do MMM")} -{" "}
                  {moment(selectedRange?.end).format(
                    "Do MMM"
                  )}
                </b>
                . <br />
                Are you sure you want to proceed?
              </p>
              <div className="gap-1 justify-end d-flex">
                <button
                  onClick={() => {
                    setIsEditConfirmationModalOpen(false);
                    // setSelectedEvent(null);
                  }}
                  className="px-3 py-1 font-semibold text-sm border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setIsEditConfirmationModalOpen(false);
                    setIsEventModalOpen(false);
                    const [start, end] =
                      selectedEvent?.time_slots?.[0]?.split("-") || [];

                    // setSelectedRange({
                    //   start: selectedEvent?.start,
                    //   end: selectedEvent?.end,
                    // });

                    setEventTitle(`${start}-${end}`);
                    setIsEdited({
                      status: true,
                      oldName: `${start}-${end}`,
                    });

                    if (isMultiDayAvailability) {
                      setSelectedStartTime(start);
                      setSelectedEndTime(end);
                      setSelectedAppointmentTypes(
                        selectedEvent?.appointment_type_ids || []
                      );
                      setSelectedZipCodes(selectedEvent?.zip_codes || []);
                      setSelectedZones([
                        ...new Set([
                          ...(selectedEvent?.zone_ids || []),
                          ...(providerDefaultZones || []),
                        ]),
                      ]);
                      setRegularDailySettings(false);
                      setIsMultiDayAvailabilityModalOpen(true);
                    }
                  }}
                  className="px-3 py-1 text-sm font-semibold text-white rounded-md bg-primaryblue"
                >
                  Proceed
                </button>
              </div>
            </span>
          </div>
        </div>
      )}

      {
        isConfModalOpen?.status && (
          <div style={modalOverlayStyle}>
            <ReusableModal
              open={isConfModalOpen?.status}
              title={"Availability Warning"}
              onClose={() => {
                setIsConfModalOpen({ status: null, message: null })
                setIsDelete(false)
              }}
            >
              <div style={modalStyle}>

                <span
                  className="flex-col d-flex"
                  style={{ padding: "10px 10px 0px 10px ", minWidth: "40vw", maxWidth: '40vw' }}
                >
                  <div className="flex flex-col gap-1 mb-2">
                    {`${isConfModalOpen?.message}Would you like to proceed?`}
                  </div>

                  <div className="gap-2 justify-end d-flex">
                    <button
                      className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                      onClick={() => {
                        setIsConfModalOpen({ status: null, message: null });
                        setIsDelete(false)
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                      onClick={() => {
                        isConfModalOpen?.isDelete ? deleteWeeklyEvent(true) : saveMultiDayAvailability(true);
                        setIsDelete(false)
                      }}
                    >
                      Proceed
                    </button>
                  </div>
                </span>
              </div>
            </ReusableModal >
          </div >
        )
      }
      {
        isSaveConfirmationModalOpen?.status && (
          <div style={modalOverlayStyle}>
            <ReusableModal
              open={isSaveConfirmationModalOpen?.status}
              title={"Availability Warning"}
              onClose={() => {
                setIsSaveConfirmationModalOpen({ status: null, message: null })
                setIsDelete(false)
              }}
            >
              <div style={modalStyle}>

                <span
                  className="flex-col d-flex"
                  style={{ padding: "10px 10px 0px 10px ", minWidth: "40vw", maxWidth: '40vw' }}
                >
                  <div className="flex flex-col gap-1 mb-2">
                    {`${isSaveConfirmationModalOpen?.message}Would you like to proceed?`}
                  </div>

                  <div className="gap-2 justify-end d-flex">
                    <button
                      className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                      onClick={() => {
                        setIsSaveConfirmationModalOpen({ status: null, message: null });
                        setIsDelete(false)
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                      onClick={() => {
                        isSaveConfirmationModalOpen?.isWeeklyEv ? saveMultiDayAvailability(isSaveConfirmationModalOpen?.isWeeklyEv) : saveMultiDayAvailability();
                        setIsSaveConfirmationModalOpen({ status: null, message: null });
                        // setIsDelete(false)
                      }}
                    >
                      Proceed
                    </button>
                  </div>
                </span>
              </div>
            </ReusableModal >
          </div >
        )
      }
    </>
  );
}
const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "10px 20px 10px 20px",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};

const componentStyle = {
  backgroundColor: "#fff",
  // padding: "1.5rem",
};

const modalButtonContainer = {
  marginTop: "20px",
  display: "flex",
  justifyContent: "space-between",
};

const dateInputContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "10px",
};

const inputWrapperStyle = {
  position: "relative",
  width: "50%",
};

const iconStyle = {
  position: "absolute",
  // right: "-9px",
  right: "-6px",
  top: "70%",
  transform: "translateY(-50%)",
  // fontSize: "18px",
  color: "#aaa",
};

const labelStyle = {
  display: "block",
  marginBottom: "5px",
  fontWeight: "bold",
  color: "#333",
  fontSize: "13px",
};

export default CalendarComponent;
